/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ChangePasswordRouteImport } from './routes/change-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAccommodationRouteImport } from './routes/_app/accommodation'
import { Route as AppChangelogRouteImport } from './routes/_app/changelog'
import { Route as AppContingentRouteImport } from './routes/_app/contingent'
import { Route as AppIncidentHelpdeskRouteImport } from './routes/_app/incident-helpdesk'
import { Route as AppInventoryRouteImport } from './routes/_app/inventory'
import { Route as AppMerchandisingRouteImport } from './routes/_app/merchandising'
import { Route as AppProfileRouteImport } from './routes/_app/profile'
import { Route as AppVolunteersRouteImport } from './routes/_app/volunteers'
import { Route as AppWslInventoryRouteImport } from './routes/_app/wsl-inventory'
import { Route as AppAccommodationIndexRouteImport } from './routes/_app/accommodation.index'
import { Route as AppAccommodationCheckInRouteImport } from './routes/_app/accommodation.check-in'
import { Route as AppAccommodationHelpdeskRouteImport } from './routes/_app/accommodation.helpdesk'
import { Route as AppAccreditationAddRouteImport } from './routes/_app/accreditation.add'
import { Route as AppAccreditationEAccreditationRouteImport } from './routes/_app/accreditation.e-accreditation'
import { Route as AppAccreditationRecordsRouteImport } from './routes/_app/accreditation.records'
import { Route as AppDashboardIndexRouteImport } from './routes/_app/dashboard.index'
import { Route as AppDashboardAccreditationRouteImport } from './routes/_app/dashboard.accreditation'
import { Route as AppDashboardEntriesRouteImport } from './routes/_app/dashboard.entries'
import { Route as AppDashboardLogisticsRouteImport } from './routes/_app/dashboard.logistics'
import { Route as AppLogisticsArrivalDepartureRouteImport } from './routes/_app/logistics.arrival-departure'
import { Route as AppLogisticsDeskRouteImport } from './routes/_app/logistics.desk'
import { Route as AppLogisticsFoodBeveragesRouteImport } from './routes/_app/logistics.food-beverages'
import { Route as AppLogisticsTransportationRouteImport } from './routes/_app/logistics.transportation'
import { Route as AppMeIndexRouteImport } from './routes/_app/me.index'
import { Route as AppMeEventsRouteImport } from './routes/_app/me.events'
import { Route as AppMeMedalsRouteImport } from './routes/_app/me.medals'
import { Route as AppMerchandisingIndexRouteImport } from './routes/_app/merchandising.index'
import { Route as AppMerchandisingCustomersRouteImport } from './routes/_app/merchandising.customers'
import { Route as AppMerchandisingOutboxRouteImport } from './routes/_app/merchandising.outbox'
import { Route as AppMerchandisingPromosRouteImport } from './routes/_app/merchandising.promos'
import { Route as AppMerchandisingStaffRouteImport } from './routes/_app/merchandising.staff'
import { Route as AppReportsIndexRouteImport } from './routes/_app/reports.index'
import { Route as AppReportsModuleRouteImport } from './routes/_app/reports.$module'
import { Route as AppReportsSetupRouteImport } from './routes/_app/reports.setup'
import { Route as AppSettingsAcCardZonesRouteImport } from './routes/_app/settings.ac-card-zones'
import { Route as AppSettingsAccessCodesRouteImport } from './routes/_app/settings.access-codes'
import { Route as AppSettingsAccessDefaultsRouteImport } from './routes/_app/settings.access-defaults'
import { Route as AppSettingsAffiliatedOrganizationsRouteImport } from './routes/_app/settings.affiliated-organizations'
import { Route as AppSettingsAirlinesRouteImport } from './routes/_app/settings.airlines'
import { Route as AppSettingsCountriesRouteImport } from './routes/_app/settings.countries'
import { Route as AppSettingsEntryPointsRouteImport } from './routes/_app/settings.entry-points'
import { Route as AppSettingsEntryWindowsRouteImport } from './routes/_app/settings.entry-windows'
import { Route as AppSettingsEventsRouteImport } from './routes/_app/settings.events'
import { Route as AppSettingsFunctionsRouteImport } from './routes/_app/settings.functions'
import { Route as AppSettingsHandoverLocationsRouteImport } from './routes/_app/settings.handover-locations'
import { Route as AppSettingsNocStagesRouteImport } from './routes/_app/settings.noc-stages'
import { Route as AppSettingsOrganizationTypesRouteImport } from './routes/_app/settings.organization-types'
import { Route as AppSettingsQuotasRouteImport } from './routes/_app/settings.quotas'
import { Route as AppSettingsRegistrationWindowsRouteImport } from './routes/_app/settings.registration-windows'
import { Route as AppSettingsResponsibleOrganizationsRouteImport } from './routes/_app/settings.responsible-organizations'
import { Route as AppSettingsSportClassesRouteImport } from './routes/_app/settings.sport-classes'
import { Route as AppSettingsSportsRouteImport } from './routes/_app/settings.sports'
import { Route as AppSettingsSubAgenciesRouteImport } from './routes/_app/settings.sub-agencies'
import { Route as AppSettingsVenuesRouteImport } from './routes/_app/settings.venues'
import { Route as AppSettingsZoneAccessRouteImport } from './routes/_app/settings.zone-access'
import { Route as AppUsersIndexRouteImport } from './routes/_app/users.index'
import { Route as AppUsersIdRouteImport } from './routes/_app/users.$id'
import { Route as AppUsersGroupsRouteImport } from './routes/_app/users.groups'
import { Route as AppUsersModulesRouteImport } from './routes/_app/users.modules'
import { Route as AppUsersSignInsRouteImport } from './routes/_app/users.sign-ins'
import { Route as AppVolunteersRecordsRouteImport } from './routes/_app/volunteers.records'
import { Route as AppAccommodationBuildingsIndexRouteImport } from './routes/_app/accommodation.buildings.index'
import { Route as AppAccommodationBuildingsBuildingIdRouteImport } from './routes/_app/accommodation.buildings.$buildingId'
import { Route as AppAccommodationRoomingIndexRouteImport } from './routes/_app/accommodation.rooming.index'
import { Route as AppAccommodationRoomingOrgIdRouteImport } from './routes/_app/accommodation.rooming.$orgId'
import { Route as AppAccreditationAddIdRouteImport } from './routes/_app/accreditation.add.$id'
import { Route as AppAccreditationEAccreditationIndexRouteImport } from './routes/_app/accreditation.e-accreditation.index'
import { Route as AppAccreditationEAccreditationCardIdRouteImport } from './routes/_app/accreditation.e-accreditation.$cardId'
import { Route as AppAccreditationEAccreditationCardsRouteImport } from './routes/_app/accreditation.e-accreditation.cards'
import { Route as AppAccreditationEAccreditationHistoryRouteImport } from './routes/_app/accreditation.e-accreditation.history'
import { Route as AppAccreditationEAccreditationPrintBatchesRouteImport } from './routes/_app/accreditation.e-accreditation.print-batches'
import { Route as AppAccreditationEntriesIndexRouteImport } from './routes/_app/accreditation.entries.index'
import { Route as AppAccreditationEntriesEbnRouteImport } from './routes/_app/accreditation.entries.ebn'
import { Route as AppAccreditationEntriesEoiRouteImport } from './routes/_app/accreditation.entries.eoi'
import { Route as AppAccreditationRecordsIdRouteImport } from './routes/_app/accreditation.records.$id'
import { Route as AppAccreditationShortlistIndexRouteImport } from './routes/_app/accreditation.shortlist.index'
import { Route as AppAccreditationShortlistSportIdRouteImport } from './routes/_app/accreditation.shortlist.$sportId'
import { Route as AppLogisticsArrivalDepartureIndexRouteImport } from './routes/_app/logistics.arrival-departure.index'
import { Route as AppLogisticsArrivalDepartureEntryPointsRouteImport } from './routes/_app/logistics.arrival-departure.entry-points'
import { Route as AppLogisticsFoodBeveragesIndexRouteImport } from './routes/_app/logistics.food-beverages.index'
import { Route as AppLogisticsFoodBeveragesHallsRouteImport } from './routes/_app/logistics.food-beverages.halls'
import { Route as AppLogisticsFoodBeveragesOrdersRouteImport } from './routes/_app/logistics.food-beverages.orders'
import { Route as AppLogisticsTransportationIndexRouteImport } from './routes/_app/logistics.transportation.index'
import { Route as AppLogisticsTransportationFleetRouteImport } from './routes/_app/logistics.transportation.fleet'
import { Route as AppLogisticsTransportationRequestsRouteImport } from './routes/_app/logistics.transportation.requests'
import { Route as AppMerchandisingOrdersIndexRouteImport } from './routes/_app/merchandising.orders.index'
import { Route as AppMerchandisingOrdersOrderIdRouteImport } from './routes/_app/merchandising.orders.$orderId'
import { Route as AppMerchandisingProductsIndexRouteImport } from './routes/_app/merchandising.products.index'
import { Route as AppMerchandisingProductsProductIdRouteImport } from './routes/_app/merchandising.products.$productId'
import { Route as AppSettingsFunctionsMainFunctionIdRouteImport } from './routes/_app/settings.functions.$mainFunctionId'
import { Route as AppSettingsSportsSportIdRouteImport } from './routes/_app/settings.sports.$sportId'
import { Route as AppUsersGroupsGroupIdRouteImport } from './routes/_app/users.groups.$groupId'
import { Route as AppLogisticsArrivalDepartureJourneysIndexRouteImport } from './routes/_app/logistics.arrival-departure.journeys.index'
import { Route as AppLogisticsTransportationDriversDriverIdRouteImport } from './routes/_app/logistics.transportation.drivers.$driverId'
import { Route as AppLogisticsTransportationRequestsRequestIdRouteImport } from './routes/_app/logistics.transportation.requests.$requestId'
import { Route as AppLogisticsArrivalDepartureJourneysDirectionGroupKeyRouteImport } from './routes/_app/logistics.arrival-departure.journeys.$direction.$groupKey'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAccommodationRoute = AppAccommodationRouteImport.update({
  id: '/accommodation',
  path: '/accommodation',
  getParentRoute: () => AppRoute,
} as any)
const AppChangelogRoute = AppChangelogRouteImport.update({
  id: '/changelog',
  path: '/changelog',
  getParentRoute: () => AppRoute,
} as any)
const AppContingentRoute = AppContingentRouteImport.update({
  id: '/contingent',
  path: '/contingent',
  getParentRoute: () => AppRoute,
} as any)
const AppIncidentHelpdeskRoute = AppIncidentHelpdeskRouteImport.update({
  id: '/incident-helpdesk',
  path: '/incident-helpdesk',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryRoute = AppInventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => AppRoute,
} as any)
const AppMerchandisingRoute = AppMerchandisingRouteImport.update({
  id: '/merchandising',
  path: '/merchandising',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppVolunteersRoute = AppVolunteersRouteImport.update({
  id: '/volunteers',
  path: '/volunteers',
  getParentRoute: () => AppRoute,
} as any)
const AppWslInventoryRoute = AppWslInventoryRouteImport.update({
  id: '/wsl-inventory',
  path: '/wsl-inventory',
  getParentRoute: () => AppRoute,
} as any)
const AppAccommodationIndexRoute = AppAccommodationIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAccommodationRoute,
} as any)
const AppAccommodationCheckInRoute = AppAccommodationCheckInRouteImport.update({
  id: '/check-in',
  path: '/check-in',
  getParentRoute: () => AppAccommodationRoute,
} as any)
const AppAccommodationHelpdeskRoute =
  AppAccommodationHelpdeskRouteImport.update({
    id: '/helpdesk',
    path: '/helpdesk',
    getParentRoute: () => AppAccommodationRoute,
  } as any)
const AppAccreditationAddRoute = AppAccreditationAddRouteImport.update({
  id: '/accreditation/add',
  path: '/accreditation/add',
  getParentRoute: () => AppRoute,
} as any)
const AppAccreditationEAccreditationRoute =
  AppAccreditationEAccreditationRouteImport.update({
    id: '/accreditation/e-accreditation',
    path: '/accreditation/e-accreditation',
    getParentRoute: () => AppRoute,
  } as any)
const AppAccreditationRecordsRoute = AppAccreditationRecordsRouteImport.update({
  id: '/accreditation/records',
  path: '/accreditation/records',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardIndexRoute = AppDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardAccreditationRoute =
  AppDashboardAccreditationRouteImport.update({
    id: '/dashboard/accreditation',
    path: '/dashboard/accreditation',
    getParentRoute: () => AppRoute,
  } as any)
const AppDashboardEntriesRoute = AppDashboardEntriesRouteImport.update({
  id: '/dashboard/entries',
  path: '/dashboard/entries',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardLogisticsRoute = AppDashboardLogisticsRouteImport.update({
  id: '/dashboard/logistics',
  path: '/dashboard/logistics',
  getParentRoute: () => AppRoute,
} as any)
const AppLogisticsArrivalDepartureRoute =
  AppLogisticsArrivalDepartureRouteImport.update({
    id: '/logistics/arrival-departure',
    path: '/logistics/arrival-departure',
    getParentRoute: () => AppRoute,
  } as any)
const AppLogisticsDeskRoute = AppLogisticsDeskRouteImport.update({
  id: '/logistics/desk',
  path: '/logistics/desk',
  getParentRoute: () => AppRoute,
} as any)
const AppLogisticsFoodBeveragesRoute =
  AppLogisticsFoodBeveragesRouteImport.update({
    id: '/logistics/food-beverages',
    path: '/logistics/food-beverages',
    getParentRoute: () => AppRoute,
  } as any)
const AppLogisticsTransportationRoute =
  AppLogisticsTransportationRouteImport.update({
    id: '/logistics/transportation',
    path: '/logistics/transportation',
    getParentRoute: () => AppRoute,
  } as any)
const AppMeIndexRoute = AppMeIndexRouteImport.update({
  id: '/me/',
  path: '/me/',
  getParentRoute: () => AppRoute,
} as any)
const AppMeEventsRoute = AppMeEventsRouteImport.update({
  id: '/me/events',
  path: '/me/events',
  getParentRoute: () => AppRoute,
} as any)
const AppMeMedalsRoute = AppMeMedalsRouteImport.update({
  id: '/me/medals',
  path: '/me/medals',
  getParentRoute: () => AppRoute,
} as any)
const AppMerchandisingIndexRoute = AppMerchandisingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppMerchandisingRoute,
} as any)
const AppMerchandisingCustomersRoute =
  AppMerchandisingCustomersRouteImport.update({
    id: '/customers',
    path: '/customers',
    getParentRoute: () => AppMerchandisingRoute,
  } as any)
const AppMerchandisingOutboxRoute = AppMerchandisingOutboxRouteImport.update({
  id: '/outbox',
  path: '/outbox',
  getParentRoute: () => AppMerchandisingRoute,
} as any)
const AppMerchandisingPromosRoute = AppMerchandisingPromosRouteImport.update({
  id: '/promos',
  path: '/promos',
  getParentRoute: () => AppMerchandisingRoute,
} as any)
const AppMerchandisingStaffRoute = AppMerchandisingStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => AppMerchandisingRoute,
} as any)
const AppReportsIndexRoute = AppReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsModuleRoute = AppReportsModuleRouteImport.update({
  id: '/reports/$module',
  path: '/reports/$module',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsSetupRoute = AppReportsSetupRouteImport.update({
  id: '/reports/setup',
  path: '/reports/setup',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsAcCardZonesRoute = AppSettingsAcCardZonesRouteImport.update({
  id: '/settings/ac-card-zones',
  path: '/settings/ac-card-zones',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsAccessCodesRoute = AppSettingsAccessCodesRouteImport.update({
  id: '/settings/access-codes',
  path: '/settings/access-codes',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsAccessDefaultsRoute =
  AppSettingsAccessDefaultsRouteImport.update({
    id: '/settings/access-defaults',
    path: '/settings/access-defaults',
    getParentRoute: () => AppRoute,
  } as any)
const AppSettingsAffiliatedOrganizationsRoute =
  AppSettingsAffiliatedOrganizationsRouteImport.update({
    id: '/settings/affiliated-organizations',
    path: '/settings/affiliated-organizations',
    getParentRoute: () => AppRoute,
  } as any)
const AppSettingsAirlinesRoute = AppSettingsAirlinesRouteImport.update({
  id: '/settings/airlines',
  path: '/settings/airlines',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsCountriesRoute = AppSettingsCountriesRouteImport.update({
  id: '/settings/countries',
  path: '/settings/countries',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsEntryPointsRoute = AppSettingsEntryPointsRouteImport.update({
  id: '/settings/entry-points',
  path: '/settings/entry-points',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsEntryWindowsRoute = AppSettingsEntryWindowsRouteImport.update({
  id: '/settings/entry-windows',
  path: '/settings/entry-windows',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsEventsRoute = AppSettingsEventsRouteImport.update({
  id: '/settings/events',
  path: '/settings/events',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsFunctionsRoute = AppSettingsFunctionsRouteImport.update({
  id: '/settings/functions',
  path: '/settings/functions',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsHandoverLocationsRoute =
  AppSettingsHandoverLocationsRouteImport.update({
    id: '/settings/handover-locations',
    path: '/settings/handover-locations',
    getParentRoute: () => AppRoute,
  } as any)
const AppSettingsNocStagesRoute = AppSettingsNocStagesRouteImport.update({
  id: '/settings/noc-stages',
  path: '/settings/noc-stages',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsOrganizationTypesRoute =
  AppSettingsOrganizationTypesRouteImport.update({
    id: '/settings/organization-types',
    path: '/settings/organization-types',
    getParentRoute: () => AppRoute,
  } as any)
const AppSettingsQuotasRoute = AppSettingsQuotasRouteImport.update({
  id: '/settings/quotas',
  path: '/settings/quotas',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRegistrationWindowsRoute =
  AppSettingsRegistrationWindowsRouteImport.update({
    id: '/settings/registration-windows',
    path: '/settings/registration-windows',
    getParentRoute: () => AppRoute,
  } as any)
const AppSettingsResponsibleOrganizationsRoute =
  AppSettingsResponsibleOrganizationsRouteImport.update({
    id: '/settings/responsible-organizations',
    path: '/settings/responsible-organizations',
    getParentRoute: () => AppRoute,
  } as any)
const AppSettingsSportClassesRoute = AppSettingsSportClassesRouteImport.update({
  id: '/settings/sport-classes',
  path: '/settings/sport-classes',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsSportsRoute = AppSettingsSportsRouteImport.update({
  id: '/settings/sports',
  path: '/settings/sports',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsSubAgenciesRoute = AppSettingsSubAgenciesRouteImport.update({
  id: '/settings/sub-agencies',
  path: '/settings/sub-agencies',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsVenuesRoute = AppSettingsVenuesRouteImport.update({
  id: '/settings/venues',
  path: '/settings/venues',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsZoneAccessRoute = AppSettingsZoneAccessRouteImport.update({
  id: '/settings/zone-access',
  path: '/settings/zone-access',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersIndexRoute = AppUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersIdRoute = AppUsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersGroupsRoute = AppUsersGroupsRouteImport.update({
  id: '/users/groups',
  path: '/users/groups',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersModulesRoute = AppUsersModulesRouteImport.update({
  id: '/users/modules',
  path: '/users/modules',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersSignInsRoute = AppUsersSignInsRouteImport.update({
  id: '/users/sign-ins',
  path: '/users/sign-ins',
  getParentRoute: () => AppRoute,
} as any)
const AppVolunteersRecordsRoute = AppVolunteersRecordsRouteImport.update({
  id: '/records',
  path: '/records',
  getParentRoute: () => AppVolunteersRoute,
} as any)
const AppAccommodationBuildingsIndexRoute =
  AppAccommodationBuildingsIndexRouteImport.update({
    id: '/buildings/',
    path: '/buildings/',
    getParentRoute: () => AppAccommodationRoute,
  } as any)
const AppAccommodationBuildingsBuildingIdRoute =
  AppAccommodationBuildingsBuildingIdRouteImport.update({
    id: '/buildings/$buildingId',
    path: '/buildings/$buildingId',
    getParentRoute: () => AppAccommodationRoute,
  } as any)
const AppAccommodationRoomingIndexRoute =
  AppAccommodationRoomingIndexRouteImport.update({
    id: '/rooming/',
    path: '/rooming/',
    getParentRoute: () => AppAccommodationRoute,
  } as any)
const AppAccommodationRoomingOrgIdRoute =
  AppAccommodationRoomingOrgIdRouteImport.update({
    id: '/rooming/$orgId',
    path: '/rooming/$orgId',
    getParentRoute: () => AppAccommodationRoute,
  } as any)
const AppAccreditationAddIdRoute = AppAccreditationAddIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppAccreditationAddRoute,
} as any)
const AppAccreditationEAccreditationIndexRoute =
  AppAccreditationEAccreditationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAccreditationEAccreditationRoute,
  } as any)
const AppAccreditationEAccreditationCardIdRoute =
  AppAccreditationEAccreditationCardIdRouteImport.update({
    id: '/$cardId',
    path: '/$cardId',
    getParentRoute: () => AppAccreditationEAccreditationRoute,
  } as any)
const AppAccreditationEAccreditationCardsRoute =
  AppAccreditationEAccreditationCardsRouteImport.update({
    id: '/cards',
    path: '/cards',
    getParentRoute: () => AppAccreditationEAccreditationRoute,
  } as any)
const AppAccreditationEAccreditationHistoryRoute =
  AppAccreditationEAccreditationHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => AppAccreditationEAccreditationRoute,
  } as any)
const AppAccreditationEAccreditationPrintBatchesRoute =
  AppAccreditationEAccreditationPrintBatchesRouteImport.update({
    id: '/print-batches',
    path: '/print-batches',
    getParentRoute: () => AppAccreditationEAccreditationRoute,
  } as any)
const AppAccreditationEntriesIndexRoute =
  AppAccreditationEntriesIndexRouteImport.update({
    id: '/accreditation/entries/',
    path: '/accreditation/entries/',
    getParentRoute: () => AppRoute,
  } as any)
const AppAccreditationEntriesEbnRoute =
  AppAccreditationEntriesEbnRouteImport.update({
    id: '/accreditation/entries/ebn',
    path: '/accreditation/entries/ebn',
    getParentRoute: () => AppRoute,
  } as any)
const AppAccreditationEntriesEoiRoute =
  AppAccreditationEntriesEoiRouteImport.update({
    id: '/accreditation/entries/eoi',
    path: '/accreditation/entries/eoi',
    getParentRoute: () => AppRoute,
  } as any)
const AppAccreditationRecordsIdRoute =
  AppAccreditationRecordsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AppAccreditationRecordsRoute,
  } as any)
const AppAccreditationShortlistIndexRoute =
  AppAccreditationShortlistIndexRouteImport.update({
    id: '/accreditation/shortlist/',
    path: '/accreditation/shortlist/',
    getParentRoute: () => AppRoute,
  } as any)
const AppAccreditationShortlistSportIdRoute =
  AppAccreditationShortlistSportIdRouteImport.update({
    id: '/accreditation/shortlist/$sportId',
    path: '/accreditation/shortlist/$sportId',
    getParentRoute: () => AppRoute,
  } as any)
const AppLogisticsArrivalDepartureIndexRoute =
  AppLogisticsArrivalDepartureIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppLogisticsArrivalDepartureRoute,
  } as any)
const AppLogisticsArrivalDepartureEntryPointsRoute =
  AppLogisticsArrivalDepartureEntryPointsRouteImport.update({
    id: '/entry-points',
    path: '/entry-points',
    getParentRoute: () => AppLogisticsArrivalDepartureRoute,
  } as any)
const AppLogisticsFoodBeveragesIndexRoute =
  AppLogisticsFoodBeveragesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppLogisticsFoodBeveragesRoute,
  } as any)
const AppLogisticsFoodBeveragesHallsRoute =
  AppLogisticsFoodBeveragesHallsRouteImport.update({
    id: '/halls',
    path: '/halls',
    getParentRoute: () => AppLogisticsFoodBeveragesRoute,
  } as any)
const AppLogisticsFoodBeveragesOrdersRoute =
  AppLogisticsFoodBeveragesOrdersRouteImport.update({
    id: '/orders',
    path: '/orders',
    getParentRoute: () => AppLogisticsFoodBeveragesRoute,
  } as any)
const AppLogisticsTransportationIndexRoute =
  AppLogisticsTransportationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppLogisticsTransportationRoute,
  } as any)
const AppLogisticsTransportationFleetRoute =
  AppLogisticsTransportationFleetRouteImport.update({
    id: '/fleet',
    path: '/fleet',
    getParentRoute: () => AppLogisticsTransportationRoute,
  } as any)
const AppLogisticsTransportationRequestsRoute =
  AppLogisticsTransportationRequestsRouteImport.update({
    id: '/requests',
    path: '/requests',
    getParentRoute: () => AppLogisticsTransportationRoute,
  } as any)
const AppMerchandisingOrdersIndexRoute =
  AppMerchandisingOrdersIndexRouteImport.update({
    id: '/orders/',
    path: '/orders/',
    getParentRoute: () => AppMerchandisingRoute,
  } as any)
const AppMerchandisingOrdersOrderIdRoute =
  AppMerchandisingOrdersOrderIdRouteImport.update({
    id: '/orders/$orderId',
    path: '/orders/$orderId',
    getParentRoute: () => AppMerchandisingRoute,
  } as any)
const AppMerchandisingProductsIndexRoute =
  AppMerchandisingProductsIndexRouteImport.update({
    id: '/products/',
    path: '/products/',
    getParentRoute: () => AppMerchandisingRoute,
  } as any)
const AppMerchandisingProductsProductIdRoute =
  AppMerchandisingProductsProductIdRouteImport.update({
    id: '/products/$productId',
    path: '/products/$productId',
    getParentRoute: () => AppMerchandisingRoute,
  } as any)
const AppSettingsFunctionsMainFunctionIdRoute =
  AppSettingsFunctionsMainFunctionIdRouteImport.update({
    id: '/$mainFunctionId',
    path: '/$mainFunctionId',
    getParentRoute: () => AppSettingsFunctionsRoute,
  } as any)
const AppSettingsSportsSportIdRoute =
  AppSettingsSportsSportIdRouteImport.update({
    id: '/$sportId',
    path: '/$sportId',
    getParentRoute: () => AppSettingsSportsRoute,
  } as any)
const AppUsersGroupsGroupIdRoute = AppUsersGroupsGroupIdRouteImport.update({
  id: '/$groupId',
  path: '/$groupId',
  getParentRoute: () => AppUsersGroupsRoute,
} as any)
const AppLogisticsArrivalDepartureJourneysIndexRoute =
  AppLogisticsArrivalDepartureJourneysIndexRouteImport.update({
    id: '/journeys/',
    path: '/journeys/',
    getParentRoute: () => AppLogisticsArrivalDepartureRoute,
  } as any)
const AppLogisticsTransportationDriversDriverIdRoute =
  AppLogisticsTransportationDriversDriverIdRouteImport.update({
    id: '/drivers/$driverId',
    path: '/drivers/$driverId',
    getParentRoute: () => AppLogisticsTransportationRoute,
  } as any)
const AppLogisticsTransportationRequestsRequestIdRoute =
  AppLogisticsTransportationRequestsRequestIdRouteImport.update({
    id: '/$requestId',
    path: '/$requestId',
    getParentRoute: () => AppLogisticsTransportationRequestsRoute,
  } as any)
const AppLogisticsArrivalDepartureJourneysDirectionGroupKeyRoute =
  AppLogisticsArrivalDepartureJourneysDirectionGroupKeyRouteImport.update({
    id: '/journeys/$direction/$groupKey',
    path: '/journeys/$direction/$groupKey',
    getParentRoute: () => AppLogisticsArrivalDepartureRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/change-password': typeof ChangePasswordRoute
  '/login': typeof LoginRoute
  '/accommodation': typeof AppAccommodationRouteWithChildren
  '/changelog': typeof AppChangelogRoute
  '/contingent': typeof AppContingentRoute
  '/incident-helpdesk': typeof AppIncidentHelpdeskRoute
  '/inventory': typeof AppInventoryRoute
  '/merchandising': typeof AppMerchandisingRouteWithChildren
  '/profile': typeof AppProfileRoute
  '/volunteers': typeof AppVolunteersRouteWithChildren
  '/wsl-inventory': typeof AppWslInventoryRoute
  '/accommodation/check-in': typeof AppAccommodationCheckInRoute
  '/accommodation/helpdesk': typeof AppAccommodationHelpdeskRoute
  '/accreditation/add': typeof AppAccreditationAddRouteWithChildren
  '/accreditation/e-accreditation': typeof AppAccreditationEAccreditationRouteWithChildren
  '/accreditation/records': typeof AppAccreditationRecordsRouteWithChildren
  '/dashboard/accreditation': typeof AppDashboardAccreditationRoute
  '/dashboard/entries': typeof AppDashboardEntriesRoute
  '/dashboard/logistics': typeof AppDashboardLogisticsRoute
  '/logistics/arrival-departure': typeof AppLogisticsArrivalDepartureRouteWithChildren
  '/logistics/desk': typeof AppLogisticsDeskRoute
  '/logistics/food-beverages': typeof AppLogisticsFoodBeveragesRouteWithChildren
  '/logistics/transportation': typeof AppLogisticsTransportationRouteWithChildren
  '/me/events': typeof AppMeEventsRoute
  '/me/medals': typeof AppMeMedalsRoute
  '/merchandising/customers': typeof AppMerchandisingCustomersRoute
  '/merchandising/outbox': typeof AppMerchandisingOutboxRoute
  '/merchandising/promos': typeof AppMerchandisingPromosRoute
  '/merchandising/staff': typeof AppMerchandisingStaffRoute
  '/reports/$module': typeof AppReportsModuleRoute
  '/reports/setup': typeof AppReportsSetupRoute
  '/settings/ac-card-zones': typeof AppSettingsAcCardZonesRoute
  '/settings/access-codes': typeof AppSettingsAccessCodesRoute
  '/settings/access-defaults': typeof AppSettingsAccessDefaultsRoute
  '/settings/affiliated-organizations': typeof AppSettingsAffiliatedOrganizationsRoute
  '/settings/airlines': typeof AppSettingsAirlinesRoute
  '/settings/countries': typeof AppSettingsCountriesRoute
  '/settings/entry-points': typeof AppSettingsEntryPointsRoute
  '/settings/entry-windows': typeof AppSettingsEntryWindowsRoute
  '/settings/events': typeof AppSettingsEventsRoute
  '/settings/functions': typeof AppSettingsFunctionsRouteWithChildren
  '/settings/handover-locations': typeof AppSettingsHandoverLocationsRoute
  '/settings/noc-stages': typeof AppSettingsNocStagesRoute
  '/settings/organization-types': typeof AppSettingsOrganizationTypesRoute
  '/settings/quotas': typeof AppSettingsQuotasRoute
  '/settings/registration-windows': typeof AppSettingsRegistrationWindowsRoute
  '/settings/responsible-organizations': typeof AppSettingsResponsibleOrganizationsRoute
  '/settings/sport-classes': typeof AppSettingsSportClassesRoute
  '/settings/sports': typeof AppSettingsSportsRouteWithChildren
  '/settings/sub-agencies': typeof AppSettingsSubAgenciesRoute
  '/settings/venues': typeof AppSettingsVenuesRoute
  '/settings/zone-access': typeof AppSettingsZoneAccessRoute
  '/users/$id': typeof AppUsersIdRoute
  '/users/groups': typeof AppUsersGroupsRouteWithChildren
  '/users/modules': typeof AppUsersModulesRoute
  '/users/sign-ins': typeof AppUsersSignInsRoute
  '/volunteers/records': typeof AppVolunteersRecordsRoute
  '/accommodation/': typeof AppAccommodationIndexRoute
  '/dashboard/': typeof AppDashboardIndexRoute
  '/me/': typeof AppMeIndexRoute
  '/merchandising/': typeof AppMerchandisingIndexRoute
  '/reports/': typeof AppReportsIndexRoute
  '/users/': typeof AppUsersIndexRoute
  '/accommodation/buildings/$buildingId': typeof AppAccommodationBuildingsBuildingIdRoute
  '/accommodation/rooming/$orgId': typeof AppAccommodationRoomingOrgIdRoute
  '/accreditation/add/$id': typeof AppAccreditationAddIdRoute
  '/accreditation/e-accreditation/$cardId': typeof AppAccreditationEAccreditationCardIdRoute
  '/accreditation/e-accreditation/cards': typeof AppAccreditationEAccreditationCardsRoute
  '/accreditation/e-accreditation/history': typeof AppAccreditationEAccreditationHistoryRoute
  '/accreditation/e-accreditation/print-batches': typeof AppAccreditationEAccreditationPrintBatchesRoute
  '/accreditation/entries/ebn': typeof AppAccreditationEntriesEbnRoute
  '/accreditation/entries/eoi': typeof AppAccreditationEntriesEoiRoute
  '/accreditation/records/$id': typeof AppAccreditationRecordsIdRoute
  '/accreditation/shortlist/$sportId': typeof AppAccreditationShortlistSportIdRoute
  '/logistics/arrival-departure/entry-points': typeof AppLogisticsArrivalDepartureEntryPointsRoute
  '/logistics/food-beverages/halls': typeof AppLogisticsFoodBeveragesHallsRoute
  '/logistics/food-beverages/orders': typeof AppLogisticsFoodBeveragesOrdersRoute
  '/logistics/transportation/fleet': typeof AppLogisticsTransportationFleetRoute
  '/logistics/transportation/requests': typeof AppLogisticsTransportationRequestsRouteWithChildren
  '/merchandising/orders/$orderId': typeof AppMerchandisingOrdersOrderIdRoute
  '/merchandising/products/$productId': typeof AppMerchandisingProductsProductIdRoute
  '/settings/functions/$mainFunctionId': typeof AppSettingsFunctionsMainFunctionIdRoute
  '/settings/sports/$sportId': typeof AppSettingsSportsSportIdRoute
  '/users/groups/$groupId': typeof AppUsersGroupsGroupIdRoute
  '/accommodation/buildings/': typeof AppAccommodationBuildingsIndexRoute
  '/accommodation/rooming/': typeof AppAccommodationRoomingIndexRoute
  '/accreditation/e-accreditation/': typeof AppAccreditationEAccreditationIndexRoute
  '/accreditation/entries/': typeof AppAccreditationEntriesIndexRoute
  '/accreditation/shortlist/': typeof AppAccreditationShortlistIndexRoute
  '/logistics/arrival-departure/': typeof AppLogisticsArrivalDepartureIndexRoute
  '/logistics/food-beverages/': typeof AppLogisticsFoodBeveragesIndexRoute
  '/logistics/transportation/': typeof AppLogisticsTransportationIndexRoute
  '/merchandising/orders/': typeof AppMerchandisingOrdersIndexRoute
  '/merchandising/products/': typeof AppMerchandisingProductsIndexRoute
  '/logistics/transportation/drivers/$driverId': typeof AppLogisticsTransportationDriversDriverIdRoute
  '/logistics/transportation/requests/$requestId': typeof AppLogisticsTransportationRequestsRequestIdRoute
  '/logistics/arrival-departure/journeys/': typeof AppLogisticsArrivalDepartureJourneysIndexRoute
  '/logistics/arrival-departure/journeys/$direction/$groupKey': typeof AppLogisticsArrivalDepartureJourneysDirectionGroupKeyRoute
}
export interface FileRoutesByTo {
  '/change-password': typeof ChangePasswordRoute
  '/login': typeof LoginRoute
  '/changelog': typeof AppChangelogRoute
  '/contingent': typeof AppContingentRoute
  '/incident-helpdesk': typeof AppIncidentHelpdeskRoute
  '/inventory': typeof AppInventoryRoute
  '/profile': typeof AppProfileRoute
  '/volunteers': typeof AppVolunteersRouteWithChildren
  '/wsl-inventory': typeof AppWslInventoryRoute
  '/': typeof AppIndexRoute
  '/accommodation/check-in': typeof AppAccommodationCheckInRoute
  '/accommodation/helpdesk': typeof AppAccommodationHelpdeskRoute
  '/accreditation/add': typeof AppAccreditationAddRouteWithChildren
  '/accreditation/records': typeof AppAccreditationRecordsRouteWithChildren
  '/dashboard/accreditation': typeof AppDashboardAccreditationRoute
  '/dashboard/entries': typeof AppDashboardEntriesRoute
  '/dashboard/logistics': typeof AppDashboardLogisticsRoute
  '/logistics/desk': typeof AppLogisticsDeskRoute
  '/me/events': typeof AppMeEventsRoute
  '/me/medals': typeof AppMeMedalsRoute
  '/merchandising/customers': typeof AppMerchandisingCustomersRoute
  '/merchandising/outbox': typeof AppMerchandisingOutboxRoute
  '/merchandising/promos': typeof AppMerchandisingPromosRoute
  '/merchandising/staff': typeof AppMerchandisingStaffRoute
  '/reports/$module': typeof AppReportsModuleRoute
  '/reports/setup': typeof AppReportsSetupRoute
  '/settings/ac-card-zones': typeof AppSettingsAcCardZonesRoute
  '/settings/access-codes': typeof AppSettingsAccessCodesRoute
  '/settings/access-defaults': typeof AppSettingsAccessDefaultsRoute
  '/settings/affiliated-organizations': typeof AppSettingsAffiliatedOrganizationsRoute
  '/settings/airlines': typeof AppSettingsAirlinesRoute
  '/settings/countries': typeof AppSettingsCountriesRoute
  '/settings/entry-points': typeof AppSettingsEntryPointsRoute
  '/settings/entry-windows': typeof AppSettingsEntryWindowsRoute
  '/settings/events': typeof AppSettingsEventsRoute
  '/settings/functions': typeof AppSettingsFunctionsRouteWithChildren
  '/settings/handover-locations': typeof AppSettingsHandoverLocationsRoute
  '/settings/noc-stages': typeof AppSettingsNocStagesRoute
  '/settings/organization-types': typeof AppSettingsOrganizationTypesRoute
  '/settings/quotas': typeof AppSettingsQuotasRoute
  '/settings/registration-windows': typeof AppSettingsRegistrationWindowsRoute
  '/settings/responsible-organizations': typeof AppSettingsResponsibleOrganizationsRoute
  '/settings/sport-classes': typeof AppSettingsSportClassesRoute
  '/settings/sports': typeof AppSettingsSportsRouteWithChildren
  '/settings/sub-agencies': typeof AppSettingsSubAgenciesRoute
  '/settings/venues': typeof AppSettingsVenuesRoute
  '/settings/zone-access': typeof AppSettingsZoneAccessRoute
  '/users/$id': typeof AppUsersIdRoute
  '/users/groups': typeof AppUsersGroupsRouteWithChildren
  '/users/modules': typeof AppUsersModulesRoute
  '/users/sign-ins': typeof AppUsersSignInsRoute
  '/volunteers/records': typeof AppVolunteersRecordsRoute
  '/accommodation': typeof AppAccommodationIndexRoute
  '/dashboard': typeof AppDashboardIndexRoute
  '/me': typeof AppMeIndexRoute
  '/merchandising': typeof AppMerchandisingIndexRoute
  '/reports': typeof AppReportsIndexRoute
  '/users': typeof AppUsersIndexRoute
  '/accommodation/buildings/$buildingId': typeof AppAccommodationBuildingsBuildingIdRoute
  '/accommodation/rooming/$orgId': typeof AppAccommodationRoomingOrgIdRoute
  '/accreditation/add/$id': typeof AppAccreditationAddIdRoute
  '/accreditation/e-accreditation/$cardId': typeof AppAccreditationEAccreditationCardIdRoute
  '/accreditation/e-accreditation/cards': typeof AppAccreditationEAccreditationCardsRoute
  '/accreditation/e-accreditation/history': typeof AppAccreditationEAccreditationHistoryRoute
  '/accreditation/e-accreditation/print-batches': typeof AppAccreditationEAccreditationPrintBatchesRoute
  '/accreditation/entries/ebn': typeof AppAccreditationEntriesEbnRoute
  '/accreditation/entries/eoi': typeof AppAccreditationEntriesEoiRoute
  '/accreditation/records/$id': typeof AppAccreditationRecordsIdRoute
  '/accreditation/shortlist/$sportId': typeof AppAccreditationShortlistSportIdRoute
  '/logistics/arrival-departure/entry-points': typeof AppLogisticsArrivalDepartureEntryPointsRoute
  '/logistics/food-beverages/halls': typeof AppLogisticsFoodBeveragesHallsRoute
  '/logistics/food-beverages/orders': typeof AppLogisticsFoodBeveragesOrdersRoute
  '/logistics/transportation/fleet': typeof AppLogisticsTransportationFleetRoute
  '/logistics/transportation/requests': typeof AppLogisticsTransportationRequestsRouteWithChildren
  '/merchandising/orders/$orderId': typeof AppMerchandisingOrdersOrderIdRoute
  '/merchandising/products/$productId': typeof AppMerchandisingProductsProductIdRoute
  '/settings/functions/$mainFunctionId': typeof AppSettingsFunctionsMainFunctionIdRoute
  '/settings/sports/$sportId': typeof AppSettingsSportsSportIdRoute
  '/users/groups/$groupId': typeof AppUsersGroupsGroupIdRoute
  '/accommodation/buildings': typeof AppAccommodationBuildingsIndexRoute
  '/accommodation/rooming': typeof AppAccommodationRoomingIndexRoute
  '/accreditation/e-accreditation': typeof AppAccreditationEAccreditationIndexRoute
  '/accreditation/entries': typeof AppAccreditationEntriesIndexRoute
  '/accreditation/shortlist': typeof AppAccreditationShortlistIndexRoute
  '/logistics/arrival-departure': typeof AppLogisticsArrivalDepartureIndexRoute
  '/logistics/food-beverages': typeof AppLogisticsFoodBeveragesIndexRoute
  '/logistics/transportation': typeof AppLogisticsTransportationIndexRoute
  '/merchandising/orders': typeof AppMerchandisingOrdersIndexRoute
  '/merchandising/products': typeof AppMerchandisingProductsIndexRoute
  '/logistics/transportation/drivers/$driverId': typeof AppLogisticsTransportationDriversDriverIdRoute
  '/logistics/transportation/requests/$requestId': typeof AppLogisticsTransportationRequestsRequestIdRoute
  '/logistics/arrival-departure/journeys': typeof AppLogisticsArrivalDepartureJourneysIndexRoute
  '/logistics/arrival-departure/journeys/$direction/$groupKey': typeof AppLogisticsArrivalDepartureJourneysDirectionGroupKeyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/change-password': typeof ChangePasswordRoute
  '/login': typeof LoginRoute
  '/_app/accommodation': typeof AppAccommodationRouteWithChildren
  '/_app/changelog': typeof AppChangelogRoute
  '/_app/contingent': typeof AppContingentRoute
  '/_app/incident-helpdesk': typeof AppIncidentHelpdeskRoute
  '/_app/inventory': typeof AppInventoryRoute
  '/_app/merchandising': typeof AppMerchandisingRouteWithChildren
  '/_app/profile': typeof AppProfileRoute
  '/_app/volunteers': typeof AppVolunteersRouteWithChildren
  '/_app/wsl-inventory': typeof AppWslInventoryRoute
  '/_app/': typeof AppIndexRoute
  '/_app/accommodation/check-in': typeof AppAccommodationCheckInRoute
  '/_app/accommodation/helpdesk': typeof AppAccommodationHelpdeskRoute
  '/_app/accreditation/add': typeof AppAccreditationAddRouteWithChildren
  '/_app/accreditation/e-accreditation': typeof AppAccreditationEAccreditationRouteWithChildren
  '/_app/accreditation/records': typeof AppAccreditationRecordsRouteWithChildren
  '/_app/dashboard/accreditation': typeof AppDashboardAccreditationRoute
  '/_app/dashboard/entries': typeof AppDashboardEntriesRoute
  '/_app/dashboard/logistics': typeof AppDashboardLogisticsRoute
  '/_app/logistics/arrival-departure': typeof AppLogisticsArrivalDepartureRouteWithChildren
  '/_app/logistics/desk': typeof AppLogisticsDeskRoute
  '/_app/logistics/food-beverages': typeof AppLogisticsFoodBeveragesRouteWithChildren
  '/_app/logistics/transportation': typeof AppLogisticsTransportationRouteWithChildren
  '/_app/me/events': typeof AppMeEventsRoute
  '/_app/me/medals': typeof AppMeMedalsRoute
  '/_app/merchandising/customers': typeof AppMerchandisingCustomersRoute
  '/_app/merchandising/outbox': typeof AppMerchandisingOutboxRoute
  '/_app/merchandising/promos': typeof AppMerchandisingPromosRoute
  '/_app/merchandising/staff': typeof AppMerchandisingStaffRoute
  '/_app/reports/$module': typeof AppReportsModuleRoute
  '/_app/reports/setup': typeof AppReportsSetupRoute
  '/_app/settings/ac-card-zones': typeof AppSettingsAcCardZonesRoute
  '/_app/settings/access-codes': typeof AppSettingsAccessCodesRoute
  '/_app/settings/access-defaults': typeof AppSettingsAccessDefaultsRoute
  '/_app/settings/affiliated-organizations': typeof AppSettingsAffiliatedOrganizationsRoute
  '/_app/settings/airlines': typeof AppSettingsAirlinesRoute
  '/_app/settings/countries': typeof AppSettingsCountriesRoute
  '/_app/settings/entry-points': typeof AppSettingsEntryPointsRoute
  '/_app/settings/entry-windows': typeof AppSettingsEntryWindowsRoute
  '/_app/settings/events': typeof AppSettingsEventsRoute
  '/_app/settings/functions': typeof AppSettingsFunctionsRouteWithChildren
  '/_app/settings/handover-locations': typeof AppSettingsHandoverLocationsRoute
  '/_app/settings/noc-stages': typeof AppSettingsNocStagesRoute
  '/_app/settings/organization-types': typeof AppSettingsOrganizationTypesRoute
  '/_app/settings/quotas': typeof AppSettingsQuotasRoute
  '/_app/settings/registration-windows': typeof AppSettingsRegistrationWindowsRoute
  '/_app/settings/responsible-organizations': typeof AppSettingsResponsibleOrganizationsRoute
  '/_app/settings/sport-classes': typeof AppSettingsSportClassesRoute
  '/_app/settings/sports': typeof AppSettingsSportsRouteWithChildren
  '/_app/settings/sub-agencies': typeof AppSettingsSubAgenciesRoute
  '/_app/settings/venues': typeof AppSettingsVenuesRoute
  '/_app/settings/zone-access': typeof AppSettingsZoneAccessRoute
  '/_app/users/$id': typeof AppUsersIdRoute
  '/_app/users/groups': typeof AppUsersGroupsRouteWithChildren
  '/_app/users/modules': typeof AppUsersModulesRoute
  '/_app/users/sign-ins': typeof AppUsersSignInsRoute
  '/_app/volunteers/records': typeof AppVolunteersRecordsRoute
  '/_app/accommodation/': typeof AppAccommodationIndexRoute
  '/_app/dashboard/': typeof AppDashboardIndexRoute
  '/_app/me/': typeof AppMeIndexRoute
  '/_app/merchandising/': typeof AppMerchandisingIndexRoute
  '/_app/reports/': typeof AppReportsIndexRoute
  '/_app/users/': typeof AppUsersIndexRoute
  '/_app/accommodation/buildings/$buildingId': typeof AppAccommodationBuildingsBuildingIdRoute
  '/_app/accommodation/rooming/$orgId': typeof AppAccommodationRoomingOrgIdRoute
  '/_app/accreditation/add/$id': typeof AppAccreditationAddIdRoute
  '/_app/accreditation/e-accreditation/$cardId': typeof AppAccreditationEAccreditationCardIdRoute
  '/_app/accreditation/e-accreditation/cards': typeof AppAccreditationEAccreditationCardsRoute
  '/_app/accreditation/e-accreditation/history': typeof AppAccreditationEAccreditationHistoryRoute
  '/_app/accreditation/e-accreditation/print-batches': typeof AppAccreditationEAccreditationPrintBatchesRoute
  '/_app/accreditation/entries/ebn': typeof AppAccreditationEntriesEbnRoute
  '/_app/accreditation/entries/eoi': typeof AppAccreditationEntriesEoiRoute
  '/_app/accreditation/records/$id': typeof AppAccreditationRecordsIdRoute
  '/_app/accreditation/shortlist/$sportId': typeof AppAccreditationShortlistSportIdRoute
  '/_app/logistics/arrival-departure/entry-points': typeof AppLogisticsArrivalDepartureEntryPointsRoute
  '/_app/logistics/food-beverages/halls': typeof AppLogisticsFoodBeveragesHallsRoute
  '/_app/logistics/food-beverages/orders': typeof AppLogisticsFoodBeveragesOrdersRoute
  '/_app/logistics/transportation/fleet': typeof AppLogisticsTransportationFleetRoute
  '/_app/logistics/transportation/requests': typeof AppLogisticsTransportationRequestsRouteWithChildren
  '/_app/merchandising/orders/$orderId': typeof AppMerchandisingOrdersOrderIdRoute
  '/_app/merchandising/products/$productId': typeof AppMerchandisingProductsProductIdRoute
  '/_app/settings/functions/$mainFunctionId': typeof AppSettingsFunctionsMainFunctionIdRoute
  '/_app/settings/sports/$sportId': typeof AppSettingsSportsSportIdRoute
  '/_app/users/groups/$groupId': typeof AppUsersGroupsGroupIdRoute
  '/_app/accommodation/buildings/': typeof AppAccommodationBuildingsIndexRoute
  '/_app/accommodation/rooming/': typeof AppAccommodationRoomingIndexRoute
  '/_app/accreditation/e-accreditation/': typeof AppAccreditationEAccreditationIndexRoute
  '/_app/accreditation/entries/': typeof AppAccreditationEntriesIndexRoute
  '/_app/accreditation/shortlist/': typeof AppAccreditationShortlistIndexRoute
  '/_app/logistics/arrival-departure/': typeof AppLogisticsArrivalDepartureIndexRoute
  '/_app/logistics/food-beverages/': typeof AppLogisticsFoodBeveragesIndexRoute
  '/_app/logistics/transportation/': typeof AppLogisticsTransportationIndexRoute
  '/_app/merchandising/orders/': typeof AppMerchandisingOrdersIndexRoute
  '/_app/merchandising/products/': typeof AppMerchandisingProductsIndexRoute
  '/_app/logistics/transportation/drivers/$driverId': typeof AppLogisticsTransportationDriversDriverIdRoute
  '/_app/logistics/transportation/requests/$requestId': typeof AppLogisticsTransportationRequestsRequestIdRoute
  '/_app/logistics/arrival-departure/journeys/': typeof AppLogisticsArrivalDepartureJourneysIndexRoute
  '/_app/logistics/arrival-departure/journeys/$direction/$groupKey': typeof AppLogisticsArrivalDepartureJourneysDirectionGroupKeyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/change-password'
    | '/login'
    | '/accommodation'
    | '/changelog'
    | '/contingent'
    | '/incident-helpdesk'
    | '/inventory'
    | '/merchandising'
    | '/profile'
    | '/volunteers'
    | '/wsl-inventory'
    | '/accommodation/check-in'
    | '/accommodation/helpdesk'
    | '/accreditation/add'
    | '/accreditation/e-accreditation'
    | '/accreditation/records'
    | '/dashboard/accreditation'
    | '/dashboard/entries'
    | '/dashboard/logistics'
    | '/logistics/arrival-departure'
    | '/logistics/desk'
    | '/logistics/food-beverages'
    | '/logistics/transportation'
    | '/me/events'
    | '/me/medals'
    | '/merchandising/customers'
    | '/merchandising/outbox'
    | '/merchandising/promos'
    | '/merchandising/staff'
    | '/reports/$module'
    | '/reports/setup'
    | '/settings/ac-card-zones'
    | '/settings/access-codes'
    | '/settings/access-defaults'
    | '/settings/affiliated-organizations'
    | '/settings/airlines'
    | '/settings/countries'
    | '/settings/entry-points'
    | '/settings/entry-windows'
    | '/settings/events'
    | '/settings/functions'
    | '/settings/handover-locations'
    | '/settings/noc-stages'
    | '/settings/organization-types'
    | '/settings/quotas'
    | '/settings/registration-windows'
    | '/settings/responsible-organizations'
    | '/settings/sport-classes'
    | '/settings/sports'
    | '/settings/sub-agencies'
    | '/settings/venues'
    | '/settings/zone-access'
    | '/users/$id'
    | '/users/groups'
    | '/users/modules'
    | '/users/sign-ins'
    | '/volunteers/records'
    | '/accommodation/'
    | '/dashboard/'
    | '/me/'
    | '/merchandising/'
    | '/reports/'
    | '/users/'
    | '/accommodation/buildings/$buildingId'
    | '/accommodation/rooming/$orgId'
    | '/accreditation/add/$id'
    | '/accreditation/e-accreditation/$cardId'
    | '/accreditation/e-accreditation/cards'
    | '/accreditation/e-accreditation/history'
    | '/accreditation/e-accreditation/print-batches'
    | '/accreditation/entries/ebn'
    | '/accreditation/entries/eoi'
    | '/accreditation/records/$id'
    | '/accreditation/shortlist/$sportId'
    | '/logistics/arrival-departure/entry-points'
    | '/logistics/food-beverages/halls'
    | '/logistics/food-beverages/orders'
    | '/logistics/transportation/fleet'
    | '/logistics/transportation/requests'
    | '/merchandising/orders/$orderId'
    | '/merchandising/products/$productId'
    | '/settings/functions/$mainFunctionId'
    | '/settings/sports/$sportId'
    | '/users/groups/$groupId'
    | '/accommodation/buildings/'
    | '/accommodation/rooming/'
    | '/accreditation/e-accreditation/'
    | '/accreditation/entries/'
    | '/accreditation/shortlist/'
    | '/logistics/arrival-departure/'
    | '/logistics/food-beverages/'
    | '/logistics/transportation/'
    | '/merchandising/orders/'
    | '/merchandising/products/'
    | '/logistics/transportation/drivers/$driverId'
    | '/logistics/transportation/requests/$requestId'
    | '/logistics/arrival-departure/journeys/'
    | '/logistics/arrival-departure/journeys/$direction/$groupKey'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/change-password'
    | '/login'
    | '/changelog'
    | '/contingent'
    | '/incident-helpdesk'
    | '/inventory'
    | '/profile'
    | '/volunteers'
    | '/wsl-inventory'
    | '/'
    | '/accommodation/check-in'
    | '/accommodation/helpdesk'
    | '/accreditation/add'
    | '/accreditation/records'
    | '/dashboard/accreditation'
    | '/dashboard/entries'
    | '/dashboard/logistics'
    | '/logistics/desk'
    | '/me/events'
    | '/me/medals'
    | '/merchandising/customers'
    | '/merchandising/outbox'
    | '/merchandising/promos'
    | '/merchandising/staff'
    | '/reports/$module'
    | '/reports/setup'
    | '/settings/ac-card-zones'
    | '/settings/access-codes'
    | '/settings/access-defaults'
    | '/settings/affiliated-organizations'
    | '/settings/airlines'
    | '/settings/countries'
    | '/settings/entry-points'
    | '/settings/entry-windows'
    | '/settings/events'
    | '/settings/functions'
    | '/settings/handover-locations'
    | '/settings/noc-stages'
    | '/settings/organization-types'
    | '/settings/quotas'
    | '/settings/registration-windows'
    | '/settings/responsible-organizations'
    | '/settings/sport-classes'
    | '/settings/sports'
    | '/settings/sub-agencies'
    | '/settings/venues'
    | '/settings/zone-access'
    | '/users/$id'
    | '/users/groups'
    | '/users/modules'
    | '/users/sign-ins'
    | '/volunteers/records'
    | '/accommodation'
    | '/dashboard'
    | '/me'
    | '/merchandising'
    | '/reports'
    | '/users'
    | '/accommodation/buildings/$buildingId'
    | '/accommodation/rooming/$orgId'
    | '/accreditation/add/$id'
    | '/accreditation/e-accreditation/$cardId'
    | '/accreditation/e-accreditation/cards'
    | '/accreditation/e-accreditation/history'
    | '/accreditation/e-accreditation/print-batches'
    | '/accreditation/entries/ebn'
    | '/accreditation/entries/eoi'
    | '/accreditation/records/$id'
    | '/accreditation/shortlist/$sportId'
    | '/logistics/arrival-departure/entry-points'
    | '/logistics/food-beverages/halls'
    | '/logistics/food-beverages/orders'
    | '/logistics/transportation/fleet'
    | '/logistics/transportation/requests'
    | '/merchandising/orders/$orderId'
    | '/merchandising/products/$productId'
    | '/settings/functions/$mainFunctionId'
    | '/settings/sports/$sportId'
    | '/users/groups/$groupId'
    | '/accommodation/buildings'
    | '/accommodation/rooming'
    | '/accreditation/e-accreditation'
    | '/accreditation/entries'
    | '/accreditation/shortlist'
    | '/logistics/arrival-departure'
    | '/logistics/food-beverages'
    | '/logistics/transportation'
    | '/merchandising/orders'
    | '/merchandising/products'
    | '/logistics/transportation/drivers/$driverId'
    | '/logistics/transportation/requests/$requestId'
    | '/logistics/arrival-departure/journeys'
    | '/logistics/arrival-departure/journeys/$direction/$groupKey'
  id:
    | '__root__'
    | '/_app'
    | '/change-password'
    | '/login'
    | '/_app/accommodation'
    | '/_app/changelog'
    | '/_app/contingent'
    | '/_app/incident-helpdesk'
    | '/_app/inventory'
    | '/_app/merchandising'
    | '/_app/profile'
    | '/_app/volunteers'
    | '/_app/wsl-inventory'
    | '/_app/'
    | '/_app/accommodation/check-in'
    | '/_app/accommodation/helpdesk'
    | '/_app/accreditation/add'
    | '/_app/accreditation/e-accreditation'
    | '/_app/accreditation/records'
    | '/_app/dashboard/accreditation'
    | '/_app/dashboard/entries'
    | '/_app/dashboard/logistics'
    | '/_app/logistics/arrival-departure'
    | '/_app/logistics/desk'
    | '/_app/logistics/food-beverages'
    | '/_app/logistics/transportation'
    | '/_app/me/events'
    | '/_app/me/medals'
    | '/_app/merchandising/customers'
    | '/_app/merchandising/outbox'
    | '/_app/merchandising/promos'
    | '/_app/merchandising/staff'
    | '/_app/reports/$module'
    | '/_app/reports/setup'
    | '/_app/settings/ac-card-zones'
    | '/_app/settings/access-codes'
    | '/_app/settings/access-defaults'
    | '/_app/settings/affiliated-organizations'
    | '/_app/settings/airlines'
    | '/_app/settings/countries'
    | '/_app/settings/entry-points'
    | '/_app/settings/entry-windows'
    | '/_app/settings/events'
    | '/_app/settings/functions'
    | '/_app/settings/handover-locations'
    | '/_app/settings/noc-stages'
    | '/_app/settings/organization-types'
    | '/_app/settings/quotas'
    | '/_app/settings/registration-windows'
    | '/_app/settings/responsible-organizations'
    | '/_app/settings/sport-classes'
    | '/_app/settings/sports'
    | '/_app/settings/sub-agencies'
    | '/_app/settings/venues'
    | '/_app/settings/zone-access'
    | '/_app/users/$id'
    | '/_app/users/groups'
    | '/_app/users/modules'
    | '/_app/users/sign-ins'
    | '/_app/volunteers/records'
    | '/_app/accommodation/'
    | '/_app/dashboard/'
    | '/_app/me/'
    | '/_app/merchandising/'
    | '/_app/reports/'
    | '/_app/users/'
    | '/_app/accommodation/buildings/$buildingId'
    | '/_app/accommodation/rooming/$orgId'
    | '/_app/accreditation/add/$id'
    | '/_app/accreditation/e-accreditation/$cardId'
    | '/_app/accreditation/e-accreditation/cards'
    | '/_app/accreditation/e-accreditation/history'
    | '/_app/accreditation/e-accreditation/print-batches'
    | '/_app/accreditation/entries/ebn'
    | '/_app/accreditation/entries/eoi'
    | '/_app/accreditation/records/$id'
    | '/_app/accreditation/shortlist/$sportId'
    | '/_app/logistics/arrival-departure/entry-points'
    | '/_app/logistics/food-beverages/halls'
    | '/_app/logistics/food-beverages/orders'
    | '/_app/logistics/transportation/fleet'
    | '/_app/logistics/transportation/requests'
    | '/_app/merchandising/orders/$orderId'
    | '/_app/merchandising/products/$productId'
    | '/_app/settings/functions/$mainFunctionId'
    | '/_app/settings/sports/$sportId'
    | '/_app/users/groups/$groupId'
    | '/_app/accommodation/buildings/'
    | '/_app/accommodation/rooming/'
    | '/_app/accreditation/e-accreditation/'
    | '/_app/accreditation/entries/'
    | '/_app/accreditation/shortlist/'
    | '/_app/logistics/arrival-departure/'
    | '/_app/logistics/food-beverages/'
    | '/_app/logistics/transportation/'
    | '/_app/merchandising/orders/'
    | '/_app/merchandising/products/'
    | '/_app/logistics/transportation/drivers/$driverId'
    | '/_app/logistics/transportation/requests/$requestId'
    | '/_app/logistics/arrival-departure/journeys/'
    | '/_app/logistics/arrival-departure/journeys/$direction/$groupKey'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  ChangePasswordRoute: typeof ChangePasswordRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accommodation': {
      id: '/_app/accommodation'
      path: '/accommodation'
      fullPath: '/accommodation'
      preLoaderRoute: typeof AppAccommodationRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/changelog': {
      id: '/_app/changelog'
      path: '/changelog'
      fullPath: '/changelog'
      preLoaderRoute: typeof AppChangelogRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contingent': {
      id: '/_app/contingent'
      path: '/contingent'
      fullPath: '/contingent'
      preLoaderRoute: typeof AppContingentRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/incident-helpdesk': {
      id: '/_app/incident-helpdesk'
      path: '/incident-helpdesk'
      fullPath: '/incident-helpdesk'
      preLoaderRoute: typeof AppIncidentHelpdeskRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory': {
      id: '/_app/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof AppInventoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/merchandising': {
      id: '/_app/merchandising'
      path: '/merchandising'
      fullPath: '/merchandising'
      preLoaderRoute: typeof AppMerchandisingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/volunteers': {
      id: '/_app/volunteers'
      path: '/volunteers'
      fullPath: '/volunteers'
      preLoaderRoute: typeof AppVolunteersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/wsl-inventory': {
      id: '/_app/wsl-inventory'
      path: '/wsl-inventory'
      fullPath: '/wsl-inventory'
      preLoaderRoute: typeof AppWslInventoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accommodation/': {
      id: '/_app/accommodation/'
      path: '/'
      fullPath: '/accommodation/'
      preLoaderRoute: typeof AppAccommodationIndexRouteImport
      parentRoute: typeof AppAccommodationRoute
    }
    '/_app/accommodation/check-in': {
      id: '/_app/accommodation/check-in'
      path: '/check-in'
      fullPath: '/accommodation/check-in'
      preLoaderRoute: typeof AppAccommodationCheckInRouteImport
      parentRoute: typeof AppAccommodationRoute
    }
    '/_app/accommodation/helpdesk': {
      id: '/_app/accommodation/helpdesk'
      path: '/helpdesk'
      fullPath: '/accommodation/helpdesk'
      preLoaderRoute: typeof AppAccommodationHelpdeskRouteImport
      parentRoute: typeof AppAccommodationRoute
    }
    '/_app/accreditation/add': {
      id: '/_app/accreditation/add'
      path: '/accreditation/add'
      fullPath: '/accreditation/add'
      preLoaderRoute: typeof AppAccreditationAddRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accreditation/e-accreditation': {
      id: '/_app/accreditation/e-accreditation'
      path: '/accreditation/e-accreditation'
      fullPath: '/accreditation/e-accreditation'
      preLoaderRoute: typeof AppAccreditationEAccreditationRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accreditation/records': {
      id: '/_app/accreditation/records'
      path: '/accreditation/records'
      fullPath: '/accreditation/records'
      preLoaderRoute: typeof AppAccreditationRecordsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard/': {
      id: '/_app/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AppDashboardIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard/accreditation': {
      id: '/_app/dashboard/accreditation'
      path: '/dashboard/accreditation'
      fullPath: '/dashboard/accreditation'
      preLoaderRoute: typeof AppDashboardAccreditationRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard/entries': {
      id: '/_app/dashboard/entries'
      path: '/dashboard/entries'
      fullPath: '/dashboard/entries'
      preLoaderRoute: typeof AppDashboardEntriesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard/logistics': {
      id: '/_app/dashboard/logistics'
      path: '/dashboard/logistics'
      fullPath: '/dashboard/logistics'
      preLoaderRoute: typeof AppDashboardLogisticsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/logistics/arrival-departure': {
      id: '/_app/logistics/arrival-departure'
      path: '/logistics/arrival-departure'
      fullPath: '/logistics/arrival-departure'
      preLoaderRoute: typeof AppLogisticsArrivalDepartureRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/logistics/desk': {
      id: '/_app/logistics/desk'
      path: '/logistics/desk'
      fullPath: '/logistics/desk'
      preLoaderRoute: typeof AppLogisticsDeskRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/logistics/food-beverages': {
      id: '/_app/logistics/food-beverages'
      path: '/logistics/food-beverages'
      fullPath: '/logistics/food-beverages'
      preLoaderRoute: typeof AppLogisticsFoodBeveragesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/logistics/transportation': {
      id: '/_app/logistics/transportation'
      path: '/logistics/transportation'
      fullPath: '/logistics/transportation'
      preLoaderRoute: typeof AppLogisticsTransportationRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me/': {
      id: '/_app/me/'
      path: '/me'
      fullPath: '/me/'
      preLoaderRoute: typeof AppMeIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me/events': {
      id: '/_app/me/events'
      path: '/me/events'
      fullPath: '/me/events'
      preLoaderRoute: typeof AppMeEventsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me/medals': {
      id: '/_app/me/medals'
      path: '/me/medals'
      fullPath: '/me/medals'
      preLoaderRoute: typeof AppMeMedalsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/merchandising/': {
      id: '/_app/merchandising/'
      path: '/'
      fullPath: '/merchandising/'
      preLoaderRoute: typeof AppMerchandisingIndexRouteImport
      parentRoute: typeof AppMerchandisingRoute
    }
    '/_app/merchandising/customers': {
      id: '/_app/merchandising/customers'
      path: '/customers'
      fullPath: '/merchandising/customers'
      preLoaderRoute: typeof AppMerchandisingCustomersRouteImport
      parentRoute: typeof AppMerchandisingRoute
    }
    '/_app/merchandising/outbox': {
      id: '/_app/merchandising/outbox'
      path: '/outbox'
      fullPath: '/merchandising/outbox'
      preLoaderRoute: typeof AppMerchandisingOutboxRouteImport
      parentRoute: typeof AppMerchandisingRoute
    }
    '/_app/merchandising/promos': {
      id: '/_app/merchandising/promos'
      path: '/promos'
      fullPath: '/merchandising/promos'
      preLoaderRoute: typeof AppMerchandisingPromosRouteImport
      parentRoute: typeof AppMerchandisingRoute
    }
    '/_app/merchandising/staff': {
      id: '/_app/merchandising/staff'
      path: '/staff'
      fullPath: '/merchandising/staff'
      preLoaderRoute: typeof AppMerchandisingStaffRouteImport
      parentRoute: typeof AppMerchandisingRoute
    }
    '/_app/reports/': {
      id: '/_app/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof AppReportsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/$module': {
      id: '/_app/reports/$module'
      path: '/reports/$module'
      fullPath: '/reports/$module'
      preLoaderRoute: typeof AppReportsModuleRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/setup': {
      id: '/_app/reports/setup'
      path: '/reports/setup'
      fullPath: '/reports/setup'
      preLoaderRoute: typeof AppReportsSetupRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/ac-card-zones': {
      id: '/_app/settings/ac-card-zones'
      path: '/settings/ac-card-zones'
      fullPath: '/settings/ac-card-zones'
      preLoaderRoute: typeof AppSettingsAcCardZonesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/access-codes': {
      id: '/_app/settings/access-codes'
      path: '/settings/access-codes'
      fullPath: '/settings/access-codes'
      preLoaderRoute: typeof AppSettingsAccessCodesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/access-defaults': {
      id: '/_app/settings/access-defaults'
      path: '/settings/access-defaults'
      fullPath: '/settings/access-defaults'
      preLoaderRoute: typeof AppSettingsAccessDefaultsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/affiliated-organizations': {
      id: '/_app/settings/affiliated-organizations'
      path: '/settings/affiliated-organizations'
      fullPath: '/settings/affiliated-organizations'
      preLoaderRoute: typeof AppSettingsAffiliatedOrganizationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/airlines': {
      id: '/_app/settings/airlines'
      path: '/settings/airlines'
      fullPath: '/settings/airlines'
      preLoaderRoute: typeof AppSettingsAirlinesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/countries': {
      id: '/_app/settings/countries'
      path: '/settings/countries'
      fullPath: '/settings/countries'
      preLoaderRoute: typeof AppSettingsCountriesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/entry-points': {
      id: '/_app/settings/entry-points'
      path: '/settings/entry-points'
      fullPath: '/settings/entry-points'
      preLoaderRoute: typeof AppSettingsEntryPointsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/entry-windows': {
      id: '/_app/settings/entry-windows'
      path: '/settings/entry-windows'
      fullPath: '/settings/entry-windows'
      preLoaderRoute: typeof AppSettingsEntryWindowsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/events': {
      id: '/_app/settings/events'
      path: '/settings/events'
      fullPath: '/settings/events'
      preLoaderRoute: typeof AppSettingsEventsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/functions': {
      id: '/_app/settings/functions'
      path: '/settings/functions'
      fullPath: '/settings/functions'
      preLoaderRoute: typeof AppSettingsFunctionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/handover-locations': {
      id: '/_app/settings/handover-locations'
      path: '/settings/handover-locations'
      fullPath: '/settings/handover-locations'
      preLoaderRoute: typeof AppSettingsHandoverLocationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/noc-stages': {
      id: '/_app/settings/noc-stages'
      path: '/settings/noc-stages'
      fullPath: '/settings/noc-stages'
      preLoaderRoute: typeof AppSettingsNocStagesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/organization-types': {
      id: '/_app/settings/organization-types'
      path: '/settings/organization-types'
      fullPath: '/settings/organization-types'
      preLoaderRoute: typeof AppSettingsOrganizationTypesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/quotas': {
      id: '/_app/settings/quotas'
      path: '/settings/quotas'
      fullPath: '/settings/quotas'
      preLoaderRoute: typeof AppSettingsQuotasRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/registration-windows': {
      id: '/_app/settings/registration-windows'
      path: '/settings/registration-windows'
      fullPath: '/settings/registration-windows'
      preLoaderRoute: typeof AppSettingsRegistrationWindowsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/responsible-organizations': {
      id: '/_app/settings/responsible-organizations'
      path: '/settings/responsible-organizations'
      fullPath: '/settings/responsible-organizations'
      preLoaderRoute: typeof AppSettingsResponsibleOrganizationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/sport-classes': {
      id: '/_app/settings/sport-classes'
      path: '/settings/sport-classes'
      fullPath: '/settings/sport-classes'
      preLoaderRoute: typeof AppSettingsSportClassesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/sports': {
      id: '/_app/settings/sports'
      path: '/settings/sports'
      fullPath: '/settings/sports'
      preLoaderRoute: typeof AppSettingsSportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/sub-agencies': {
      id: '/_app/settings/sub-agencies'
      path: '/settings/sub-agencies'
      fullPath: '/settings/sub-agencies'
      preLoaderRoute: typeof AppSettingsSubAgenciesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/venues': {
      id: '/_app/settings/venues'
      path: '/settings/venues'
      fullPath: '/settings/venues'
      preLoaderRoute: typeof AppSettingsVenuesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/zone-access': {
      id: '/_app/settings/zone-access'
      path: '/settings/zone-access'
      fullPath: '/settings/zone-access'
      preLoaderRoute: typeof AppSettingsZoneAccessRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/': {
      id: '/_app/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AppUsersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/$id': {
      id: '/_app/users/$id'
      path: '/users/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof AppUsersIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/groups': {
      id: '/_app/users/groups'
      path: '/users/groups'
      fullPath: '/users/groups'
      preLoaderRoute: typeof AppUsersGroupsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/modules': {
      id: '/_app/users/modules'
      path: '/users/modules'
      fullPath: '/users/modules'
      preLoaderRoute: typeof AppUsersModulesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/sign-ins': {
      id: '/_app/users/sign-ins'
      path: '/users/sign-ins'
      fullPath: '/users/sign-ins'
      preLoaderRoute: typeof AppUsersSignInsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/volunteers/records': {
      id: '/_app/volunteers/records'
      path: '/records'
      fullPath: '/volunteers/records'
      preLoaderRoute: typeof AppVolunteersRecordsRouteImport
      parentRoute: typeof AppVolunteersRoute
    }
    '/_app/accommodation/buildings/': {
      id: '/_app/accommodation/buildings/'
      path: '/buildings'
      fullPath: '/accommodation/buildings/'
      preLoaderRoute: typeof AppAccommodationBuildingsIndexRouteImport
      parentRoute: typeof AppAccommodationRoute
    }
    '/_app/accommodation/buildings/$buildingId': {
      id: '/_app/accommodation/buildings/$buildingId'
      path: '/buildings/$buildingId'
      fullPath: '/accommodation/buildings/$buildingId'
      preLoaderRoute: typeof AppAccommodationBuildingsBuildingIdRouteImport
      parentRoute: typeof AppAccommodationRoute
    }
    '/_app/accommodation/rooming/': {
      id: '/_app/accommodation/rooming/'
      path: '/rooming'
      fullPath: '/accommodation/rooming/'
      preLoaderRoute: typeof AppAccommodationRoomingIndexRouteImport
      parentRoute: typeof AppAccommodationRoute
    }
    '/_app/accommodation/rooming/$orgId': {
      id: '/_app/accommodation/rooming/$orgId'
      path: '/rooming/$orgId'
      fullPath: '/accommodation/rooming/$orgId'
      preLoaderRoute: typeof AppAccommodationRoomingOrgIdRouteImport
      parentRoute: typeof AppAccommodationRoute
    }
    '/_app/accreditation/add/$id': {
      id: '/_app/accreditation/add/$id'
      path: '/$id'
      fullPath: '/accreditation/add/$id'
      preLoaderRoute: typeof AppAccreditationAddIdRouteImport
      parentRoute: typeof AppAccreditationAddRoute
    }
    '/_app/accreditation/e-accreditation/': {
      id: '/_app/accreditation/e-accreditation/'
      path: '/'
      fullPath: '/accreditation/e-accreditation/'
      preLoaderRoute: typeof AppAccreditationEAccreditationIndexRouteImport
      parentRoute: typeof AppAccreditationEAccreditationRoute
    }
    '/_app/accreditation/e-accreditation/$cardId': {
      id: '/_app/accreditation/e-accreditation/$cardId'
      path: '/$cardId'
      fullPath: '/accreditation/e-accreditation/$cardId'
      preLoaderRoute: typeof AppAccreditationEAccreditationCardIdRouteImport
      parentRoute: typeof AppAccreditationEAccreditationRoute
    }
    '/_app/accreditation/e-accreditation/cards': {
      id: '/_app/accreditation/e-accreditation/cards'
      path: '/cards'
      fullPath: '/accreditation/e-accreditation/cards'
      preLoaderRoute: typeof AppAccreditationEAccreditationCardsRouteImport
      parentRoute: typeof AppAccreditationEAccreditationRoute
    }
    '/_app/accreditation/e-accreditation/history': {
      id: '/_app/accreditation/e-accreditation/history'
      path: '/history'
      fullPath: '/accreditation/e-accreditation/history'
      preLoaderRoute: typeof AppAccreditationEAccreditationHistoryRouteImport
      parentRoute: typeof AppAccreditationEAccreditationRoute
    }
    '/_app/accreditation/e-accreditation/print-batches': {
      id: '/_app/accreditation/e-accreditation/print-batches'
      path: '/print-batches'
      fullPath: '/accreditation/e-accreditation/print-batches'
      preLoaderRoute: typeof AppAccreditationEAccreditationPrintBatchesRouteImport
      parentRoute: typeof AppAccreditationEAccreditationRoute
    }
    '/_app/accreditation/entries/': {
      id: '/_app/accreditation/entries/'
      path: '/accreditation/entries'
      fullPath: '/accreditation/entries/'
      preLoaderRoute: typeof AppAccreditationEntriesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accreditation/entries/ebn': {
      id: '/_app/accreditation/entries/ebn'
      path: '/accreditation/entries/ebn'
      fullPath: '/accreditation/entries/ebn'
      preLoaderRoute: typeof AppAccreditationEntriesEbnRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accreditation/entries/eoi': {
      id: '/_app/accreditation/entries/eoi'
      path: '/accreditation/entries/eoi'
      fullPath: '/accreditation/entries/eoi'
      preLoaderRoute: typeof AppAccreditationEntriesEoiRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accreditation/records/$id': {
      id: '/_app/accreditation/records/$id'
      path: '/$id'
      fullPath: '/accreditation/records/$id'
      preLoaderRoute: typeof AppAccreditationRecordsIdRouteImport
      parentRoute: typeof AppAccreditationRecordsRoute
    }
    '/_app/accreditation/shortlist/': {
      id: '/_app/accreditation/shortlist/'
      path: '/accreditation/shortlist'
      fullPath: '/accreditation/shortlist/'
      preLoaderRoute: typeof AppAccreditationShortlistIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accreditation/shortlist/$sportId': {
      id: '/_app/accreditation/shortlist/$sportId'
      path: '/accreditation/shortlist/$sportId'
      fullPath: '/accreditation/shortlist/$sportId'
      preLoaderRoute: typeof AppAccreditationShortlistSportIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/logistics/arrival-departure/': {
      id: '/_app/logistics/arrival-departure/'
      path: '/'
      fullPath: '/logistics/arrival-departure/'
      preLoaderRoute: typeof AppLogisticsArrivalDepartureIndexRouteImport
      parentRoute: typeof AppLogisticsArrivalDepartureRoute
    }
    '/_app/logistics/arrival-departure/entry-points': {
      id: '/_app/logistics/arrival-departure/entry-points'
      path: '/entry-points'
      fullPath: '/logistics/arrival-departure/entry-points'
      preLoaderRoute: typeof AppLogisticsArrivalDepartureEntryPointsRouteImport
      parentRoute: typeof AppLogisticsArrivalDepartureRoute
    }
    '/_app/logistics/food-beverages/': {
      id: '/_app/logistics/food-beverages/'
      path: '/'
      fullPath: '/logistics/food-beverages/'
      preLoaderRoute: typeof AppLogisticsFoodBeveragesIndexRouteImport
      parentRoute: typeof AppLogisticsFoodBeveragesRoute
    }
    '/_app/logistics/food-beverages/halls': {
      id: '/_app/logistics/food-beverages/halls'
      path: '/halls'
      fullPath: '/logistics/food-beverages/halls'
      preLoaderRoute: typeof AppLogisticsFoodBeveragesHallsRouteImport
      parentRoute: typeof AppLogisticsFoodBeveragesRoute
    }
    '/_app/logistics/food-beverages/orders': {
      id: '/_app/logistics/food-beverages/orders'
      path: '/orders'
      fullPath: '/logistics/food-beverages/orders'
      preLoaderRoute: typeof AppLogisticsFoodBeveragesOrdersRouteImport
      parentRoute: typeof AppLogisticsFoodBeveragesRoute
    }
    '/_app/logistics/transportation/': {
      id: '/_app/logistics/transportation/'
      path: '/'
      fullPath: '/logistics/transportation/'
      preLoaderRoute: typeof AppLogisticsTransportationIndexRouteImport
      parentRoute: typeof AppLogisticsTransportationRoute
    }
    '/_app/logistics/transportation/fleet': {
      id: '/_app/logistics/transportation/fleet'
      path: '/fleet'
      fullPath: '/logistics/transportation/fleet'
      preLoaderRoute: typeof AppLogisticsTransportationFleetRouteImport
      parentRoute: typeof AppLogisticsTransportationRoute
    }
    '/_app/logistics/transportation/requests': {
      id: '/_app/logistics/transportation/requests'
      path: '/requests'
      fullPath: '/logistics/transportation/requests'
      preLoaderRoute: typeof AppLogisticsTransportationRequestsRouteImport
      parentRoute: typeof AppLogisticsTransportationRoute
    }
    '/_app/merchandising/orders/': {
      id: '/_app/merchandising/orders/'
      path: '/orders'
      fullPath: '/merchandising/orders/'
      preLoaderRoute: typeof AppMerchandisingOrdersIndexRouteImport
      parentRoute: typeof AppMerchandisingRoute
    }
    '/_app/merchandising/orders/$orderId': {
      id: '/_app/merchandising/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/merchandising/orders/$orderId'
      preLoaderRoute: typeof AppMerchandisingOrdersOrderIdRouteImport
      parentRoute: typeof AppMerchandisingRoute
    }
    '/_app/merchandising/products/': {
      id: '/_app/merchandising/products/'
      path: '/products'
      fullPath: '/merchandising/products/'
      preLoaderRoute: typeof AppMerchandisingProductsIndexRouteImport
      parentRoute: typeof AppMerchandisingRoute
    }
    '/_app/merchandising/products/$productId': {
      id: '/_app/merchandising/products/$productId'
      path: '/products/$productId'
      fullPath: '/merchandising/products/$productId'
      preLoaderRoute: typeof AppMerchandisingProductsProductIdRouteImport
      parentRoute: typeof AppMerchandisingRoute
    }
    '/_app/settings/functions/$mainFunctionId': {
      id: '/_app/settings/functions/$mainFunctionId'
      path: '/$mainFunctionId'
      fullPath: '/settings/functions/$mainFunctionId'
      preLoaderRoute: typeof AppSettingsFunctionsMainFunctionIdRouteImport
      parentRoute: typeof AppSettingsFunctionsRoute
    }
    '/_app/settings/sports/$sportId': {
      id: '/_app/settings/sports/$sportId'
      path: '/$sportId'
      fullPath: '/settings/sports/$sportId'
      preLoaderRoute: typeof AppSettingsSportsSportIdRouteImport
      parentRoute: typeof AppSettingsSportsRoute
    }
    '/_app/users/groups/$groupId': {
      id: '/_app/users/groups/$groupId'
      path: '/$groupId'
      fullPath: '/users/groups/$groupId'
      preLoaderRoute: typeof AppUsersGroupsGroupIdRouteImport
      parentRoute: typeof AppUsersGroupsRoute
    }
    '/_app/logistics/arrival-departure/journeys/': {
      id: '/_app/logistics/arrival-departure/journeys/'
      path: '/journeys'
      fullPath: '/logistics/arrival-departure/journeys/'
      preLoaderRoute: typeof AppLogisticsArrivalDepartureJourneysIndexRouteImport
      parentRoute: typeof AppLogisticsArrivalDepartureRoute
    }
    '/_app/logistics/transportation/drivers/$driverId': {
      id: '/_app/logistics/transportation/drivers/$driverId'
      path: '/drivers/$driverId'
      fullPath: '/logistics/transportation/drivers/$driverId'
      preLoaderRoute: typeof AppLogisticsTransportationDriversDriverIdRouteImport
      parentRoute: typeof AppLogisticsTransportationRoute
    }
    '/_app/logistics/transportation/requests/$requestId': {
      id: '/_app/logistics/transportation/requests/$requestId'
      path: '/$requestId'
      fullPath: '/logistics/transportation/requests/$requestId'
      preLoaderRoute: typeof AppLogisticsTransportationRequestsRequestIdRouteImport
      parentRoute: typeof AppLogisticsTransportationRequestsRoute
    }
    '/_app/logistics/arrival-departure/journeys/$direction/$groupKey': {
      id: '/_app/logistics/arrival-departure/journeys/$direction/$groupKey'
      path: '/journeys/$direction/$groupKey'
      fullPath: '/logistics/arrival-departure/journeys/$direction/$groupKey'
      preLoaderRoute: typeof AppLogisticsArrivalDepartureJourneysDirectionGroupKeyRouteImport
      parentRoute: typeof AppLogisticsArrivalDepartureRoute
    }
  }
}

interface AppAccommodationRouteChildren {
  AppAccommodationCheckInRoute: typeof AppAccommodationCheckInRoute
  AppAccommodationHelpdeskRoute: typeof AppAccommodationHelpdeskRoute
  AppAccommodationIndexRoute: typeof AppAccommodationIndexRoute
  AppAccommodationBuildingsBuildingIdRoute: typeof AppAccommodationBuildingsBuildingIdRoute
  AppAccommodationRoomingOrgIdRoute: typeof AppAccommodationRoomingOrgIdRoute
  AppAccommodationBuildingsIndexRoute: typeof AppAccommodationBuildingsIndexRoute
  AppAccommodationRoomingIndexRoute: typeof AppAccommodationRoomingIndexRoute
}

const AppAccommodationRouteChildren: AppAccommodationRouteChildren = {
  AppAccommodationCheckInRoute: AppAccommodationCheckInRoute,
  AppAccommodationHelpdeskRoute: AppAccommodationHelpdeskRoute,
  AppAccommodationIndexRoute: AppAccommodationIndexRoute,
  AppAccommodationBuildingsBuildingIdRoute:
    AppAccommodationBuildingsBuildingIdRoute,
  AppAccommodationRoomingOrgIdRoute: AppAccommodationRoomingOrgIdRoute,
  AppAccommodationBuildingsIndexRoute: AppAccommodationBuildingsIndexRoute,
  AppAccommodationRoomingIndexRoute: AppAccommodationRoomingIndexRoute,
}

const AppAccommodationRouteWithChildren =
  AppAccommodationRoute._addFileChildren(AppAccommodationRouteChildren)

interface AppMerchandisingRouteChildren {
  AppMerchandisingCustomersRoute: typeof AppMerchandisingCustomersRoute
  AppMerchandisingOutboxRoute: typeof AppMerchandisingOutboxRoute
  AppMerchandisingPromosRoute: typeof AppMerchandisingPromosRoute
  AppMerchandisingStaffRoute: typeof AppMerchandisingStaffRoute
  AppMerchandisingIndexRoute: typeof AppMerchandisingIndexRoute
  AppMerchandisingOrdersOrderIdRoute: typeof AppMerchandisingOrdersOrderIdRoute
  AppMerchandisingProductsProductIdRoute: typeof AppMerchandisingProductsProductIdRoute
  AppMerchandisingOrdersIndexRoute: typeof AppMerchandisingOrdersIndexRoute
  AppMerchandisingProductsIndexRoute: typeof AppMerchandisingProductsIndexRoute
}

const AppMerchandisingRouteChildren: AppMerchandisingRouteChildren = {
  AppMerchandisingCustomersRoute: AppMerchandisingCustomersRoute,
  AppMerchandisingOutboxRoute: AppMerchandisingOutboxRoute,
  AppMerchandisingPromosRoute: AppMerchandisingPromosRoute,
  AppMerchandisingStaffRoute: AppMerchandisingStaffRoute,
  AppMerchandisingIndexRoute: AppMerchandisingIndexRoute,
  AppMerchandisingOrdersOrderIdRoute: AppMerchandisingOrdersOrderIdRoute,
  AppMerchandisingProductsProductIdRoute:
    AppMerchandisingProductsProductIdRoute,
  AppMerchandisingOrdersIndexRoute: AppMerchandisingOrdersIndexRoute,
  AppMerchandisingProductsIndexRoute: AppMerchandisingProductsIndexRoute,
}

const AppMerchandisingRouteWithChildren =
  AppMerchandisingRoute._addFileChildren(AppMerchandisingRouteChildren)

interface AppVolunteersRouteChildren {
  AppVolunteersRecordsRoute: typeof AppVolunteersRecordsRoute
}

const AppVolunteersRouteChildren: AppVolunteersRouteChildren = {
  AppVolunteersRecordsRoute: AppVolunteersRecordsRoute,
}

const AppVolunteersRouteWithChildren = AppVolunteersRoute._addFileChildren(
  AppVolunteersRouteChildren,
)

interface AppAccreditationAddRouteChildren {
  AppAccreditationAddIdRoute: typeof AppAccreditationAddIdRoute
}

const AppAccreditationAddRouteChildren: AppAccreditationAddRouteChildren = {
  AppAccreditationAddIdRoute: AppAccreditationAddIdRoute,
}

const AppAccreditationAddRouteWithChildren =
  AppAccreditationAddRoute._addFileChildren(AppAccreditationAddRouteChildren)

interface AppAccreditationEAccreditationRouteChildren {
  AppAccreditationEAccreditationCardIdRoute: typeof AppAccreditationEAccreditationCardIdRoute
  AppAccreditationEAccreditationCardsRoute: typeof AppAccreditationEAccreditationCardsRoute
  AppAccreditationEAccreditationHistoryRoute: typeof AppAccreditationEAccreditationHistoryRoute
  AppAccreditationEAccreditationPrintBatchesRoute: typeof AppAccreditationEAccreditationPrintBatchesRoute
  AppAccreditationEAccreditationIndexRoute: typeof AppAccreditationEAccreditationIndexRoute
}

const AppAccreditationEAccreditationRouteChildren: AppAccreditationEAccreditationRouteChildren =
  {
    AppAccreditationEAccreditationCardIdRoute:
      AppAccreditationEAccreditationCardIdRoute,
    AppAccreditationEAccreditationCardsRoute:
      AppAccreditationEAccreditationCardsRoute,
    AppAccreditationEAccreditationHistoryRoute:
      AppAccreditationEAccreditationHistoryRoute,
    AppAccreditationEAccreditationPrintBatchesRoute:
      AppAccreditationEAccreditationPrintBatchesRoute,
    AppAccreditationEAccreditationIndexRoute:
      AppAccreditationEAccreditationIndexRoute,
  }

const AppAccreditationEAccreditationRouteWithChildren =
  AppAccreditationEAccreditationRoute._addFileChildren(
    AppAccreditationEAccreditationRouteChildren,
  )

interface AppAccreditationRecordsRouteChildren {
  AppAccreditationRecordsIdRoute: typeof AppAccreditationRecordsIdRoute
}

const AppAccreditationRecordsRouteChildren: AppAccreditationRecordsRouteChildren =
  {
    AppAccreditationRecordsIdRoute: AppAccreditationRecordsIdRoute,
  }

const AppAccreditationRecordsRouteWithChildren =
  AppAccreditationRecordsRoute._addFileChildren(
    AppAccreditationRecordsRouteChildren,
  )

interface AppLogisticsArrivalDepartureRouteChildren {
  AppLogisticsArrivalDepartureEntryPointsRoute: typeof AppLogisticsArrivalDepartureEntryPointsRoute
  AppLogisticsArrivalDepartureIndexRoute: typeof AppLogisticsArrivalDepartureIndexRoute
  AppLogisticsArrivalDepartureJourneysIndexRoute: typeof AppLogisticsArrivalDepartureJourneysIndexRoute
  AppLogisticsArrivalDepartureJourneysDirectionGroupKeyRoute: typeof AppLogisticsArrivalDepartureJourneysDirectionGroupKeyRoute
}

const AppLogisticsArrivalDepartureRouteChildren: AppLogisticsArrivalDepartureRouteChildren =
  {
    AppLogisticsArrivalDepartureEntryPointsRoute:
      AppLogisticsArrivalDepartureEntryPointsRoute,
    AppLogisticsArrivalDepartureIndexRoute:
      AppLogisticsArrivalDepartureIndexRoute,
    AppLogisticsArrivalDepartureJourneysIndexRoute:
      AppLogisticsArrivalDepartureJourneysIndexRoute,
    AppLogisticsArrivalDepartureJourneysDirectionGroupKeyRoute:
      AppLogisticsArrivalDepartureJourneysDirectionGroupKeyRoute,
  }

const AppLogisticsArrivalDepartureRouteWithChildren =
  AppLogisticsArrivalDepartureRoute._addFileChildren(
    AppLogisticsArrivalDepartureRouteChildren,
  )

interface AppLogisticsFoodBeveragesRouteChildren {
  AppLogisticsFoodBeveragesHallsRoute: typeof AppLogisticsFoodBeveragesHallsRoute
  AppLogisticsFoodBeveragesOrdersRoute: typeof AppLogisticsFoodBeveragesOrdersRoute
  AppLogisticsFoodBeveragesIndexRoute: typeof AppLogisticsFoodBeveragesIndexRoute
}

const AppLogisticsFoodBeveragesRouteChildren: AppLogisticsFoodBeveragesRouteChildren =
  {
    AppLogisticsFoodBeveragesHallsRoute: AppLogisticsFoodBeveragesHallsRoute,
    AppLogisticsFoodBeveragesOrdersRoute: AppLogisticsFoodBeveragesOrdersRoute,
    AppLogisticsFoodBeveragesIndexRoute: AppLogisticsFoodBeveragesIndexRoute,
  }

const AppLogisticsFoodBeveragesRouteWithChildren =
  AppLogisticsFoodBeveragesRoute._addFileChildren(
    AppLogisticsFoodBeveragesRouteChildren,
  )

interface AppLogisticsTransportationRequestsRouteChildren {
  AppLogisticsTransportationRequestsRequestIdRoute: typeof AppLogisticsTransportationRequestsRequestIdRoute
}

const AppLogisticsTransportationRequestsRouteChildren: AppLogisticsTransportationRequestsRouteChildren =
  {
    AppLogisticsTransportationRequestsRequestIdRoute:
      AppLogisticsTransportationRequestsRequestIdRoute,
  }

const AppLogisticsTransportationRequestsRouteWithChildren =
  AppLogisticsTransportationRequestsRoute._addFileChildren(
    AppLogisticsTransportationRequestsRouteChildren,
  )

interface AppLogisticsTransportationRouteChildren {
  AppLogisticsTransportationFleetRoute: typeof AppLogisticsTransportationFleetRoute
  AppLogisticsTransportationRequestsRoute: typeof AppLogisticsTransportationRequestsRouteWithChildren
  AppLogisticsTransportationIndexRoute: typeof AppLogisticsTransportationIndexRoute
  AppLogisticsTransportationDriversDriverIdRoute: typeof AppLogisticsTransportationDriversDriverIdRoute
}

const AppLogisticsTransportationRouteChildren: AppLogisticsTransportationRouteChildren =
  {
    AppLogisticsTransportationFleetRoute: AppLogisticsTransportationFleetRoute,
    AppLogisticsTransportationRequestsRoute:
      AppLogisticsTransportationRequestsRouteWithChildren,
    AppLogisticsTransportationIndexRoute: AppLogisticsTransportationIndexRoute,
    AppLogisticsTransportationDriversDriverIdRoute:
      AppLogisticsTransportationDriversDriverIdRoute,
  }

const AppLogisticsTransportationRouteWithChildren =
  AppLogisticsTransportationRoute._addFileChildren(
    AppLogisticsTransportationRouteChildren,
  )

interface AppSettingsFunctionsRouteChildren {
  AppSettingsFunctionsMainFunctionIdRoute: typeof AppSettingsFunctionsMainFunctionIdRoute
}

const AppSettingsFunctionsRouteChildren: AppSettingsFunctionsRouteChildren = {
  AppSettingsFunctionsMainFunctionIdRoute:
    AppSettingsFunctionsMainFunctionIdRoute,
}

const AppSettingsFunctionsRouteWithChildren =
  AppSettingsFunctionsRoute._addFileChildren(AppSettingsFunctionsRouteChildren)

interface AppSettingsSportsRouteChildren {
  AppSettingsSportsSportIdRoute: typeof AppSettingsSportsSportIdRoute
}

const AppSettingsSportsRouteChildren: AppSettingsSportsRouteChildren = {
  AppSettingsSportsSportIdRoute: AppSettingsSportsSportIdRoute,
}

const AppSettingsSportsRouteWithChildren =
  AppSettingsSportsRoute._addFileChildren(AppSettingsSportsRouteChildren)

interface AppUsersGroupsRouteChildren {
  AppUsersGroupsGroupIdRoute: typeof AppUsersGroupsGroupIdRoute
}

const AppUsersGroupsRouteChildren: AppUsersGroupsRouteChildren = {
  AppUsersGroupsGroupIdRoute: AppUsersGroupsGroupIdRoute,
}

const AppUsersGroupsRouteWithChildren = AppUsersGroupsRoute._addFileChildren(
  AppUsersGroupsRouteChildren,
)

interface AppRouteChildren {
  AppAccommodationRoute: typeof AppAccommodationRouteWithChildren
  AppChangelogRoute: typeof AppChangelogRoute
  AppContingentRoute: typeof AppContingentRoute
  AppIncidentHelpdeskRoute: typeof AppIncidentHelpdeskRoute
  AppInventoryRoute: typeof AppInventoryRoute
  AppMerchandisingRoute: typeof AppMerchandisingRouteWithChildren
  AppProfileRoute: typeof AppProfileRoute
  AppVolunteersRoute: typeof AppVolunteersRouteWithChildren
  AppWslInventoryRoute: typeof AppWslInventoryRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAccreditationAddRoute: typeof AppAccreditationAddRouteWithChildren
  AppAccreditationEAccreditationRoute: typeof AppAccreditationEAccreditationRouteWithChildren
  AppAccreditationRecordsRoute: typeof AppAccreditationRecordsRouteWithChildren
  AppDashboardAccreditationRoute: typeof AppDashboardAccreditationRoute
  AppDashboardEntriesRoute: typeof AppDashboardEntriesRoute
  AppDashboardLogisticsRoute: typeof AppDashboardLogisticsRoute
  AppLogisticsArrivalDepartureRoute: typeof AppLogisticsArrivalDepartureRouteWithChildren
  AppLogisticsDeskRoute: typeof AppLogisticsDeskRoute
  AppLogisticsFoodBeveragesRoute: typeof AppLogisticsFoodBeveragesRouteWithChildren
  AppLogisticsTransportationRoute: typeof AppLogisticsTransportationRouteWithChildren
  AppMeEventsRoute: typeof AppMeEventsRoute
  AppMeMedalsRoute: typeof AppMeMedalsRoute
  AppReportsModuleRoute: typeof AppReportsModuleRoute
  AppReportsSetupRoute: typeof AppReportsSetupRoute
  AppSettingsAcCardZonesRoute: typeof AppSettingsAcCardZonesRoute
  AppSettingsAccessCodesRoute: typeof AppSettingsAccessCodesRoute
  AppSettingsAccessDefaultsRoute: typeof AppSettingsAccessDefaultsRoute
  AppSettingsAffiliatedOrganizationsRoute: typeof AppSettingsAffiliatedOrganizationsRoute
  AppSettingsAirlinesRoute: typeof AppSettingsAirlinesRoute
  AppSettingsCountriesRoute: typeof AppSettingsCountriesRoute
  AppSettingsEntryPointsRoute: typeof AppSettingsEntryPointsRoute
  AppSettingsEntryWindowsRoute: typeof AppSettingsEntryWindowsRoute
  AppSettingsEventsRoute: typeof AppSettingsEventsRoute
  AppSettingsFunctionsRoute: typeof AppSettingsFunctionsRouteWithChildren
  AppSettingsHandoverLocationsRoute: typeof AppSettingsHandoverLocationsRoute
  AppSettingsNocStagesRoute: typeof AppSettingsNocStagesRoute
  AppSettingsOrganizationTypesRoute: typeof AppSettingsOrganizationTypesRoute
  AppSettingsQuotasRoute: typeof AppSettingsQuotasRoute
  AppSettingsRegistrationWindowsRoute: typeof AppSettingsRegistrationWindowsRoute
  AppSettingsResponsibleOrganizationsRoute: typeof AppSettingsResponsibleOrganizationsRoute
  AppSettingsSportClassesRoute: typeof AppSettingsSportClassesRoute
  AppSettingsSportsRoute: typeof AppSettingsSportsRouteWithChildren
  AppSettingsSubAgenciesRoute: typeof AppSettingsSubAgenciesRoute
  AppSettingsVenuesRoute: typeof AppSettingsVenuesRoute
  AppSettingsZoneAccessRoute: typeof AppSettingsZoneAccessRoute
  AppUsersIdRoute: typeof AppUsersIdRoute
  AppUsersGroupsRoute: typeof AppUsersGroupsRouteWithChildren
  AppUsersModulesRoute: typeof AppUsersModulesRoute
  AppUsersSignInsRoute: typeof AppUsersSignInsRoute
  AppDashboardIndexRoute: typeof AppDashboardIndexRoute
  AppMeIndexRoute: typeof AppMeIndexRoute
  AppReportsIndexRoute: typeof AppReportsIndexRoute
  AppUsersIndexRoute: typeof AppUsersIndexRoute
  AppAccreditationEntriesEbnRoute: typeof AppAccreditationEntriesEbnRoute
  AppAccreditationEntriesEoiRoute: typeof AppAccreditationEntriesEoiRoute
  AppAccreditationShortlistSportIdRoute: typeof AppAccreditationShortlistSportIdRoute
  AppAccreditationEntriesIndexRoute: typeof AppAccreditationEntriesIndexRoute
  AppAccreditationShortlistIndexRoute: typeof AppAccreditationShortlistIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccommodationRoute: AppAccommodationRouteWithChildren,
  AppChangelogRoute: AppChangelogRoute,
  AppContingentRoute: AppContingentRoute,
  AppIncidentHelpdeskRoute: AppIncidentHelpdeskRoute,
  AppInventoryRoute: AppInventoryRoute,
  AppMerchandisingRoute: AppMerchandisingRouteWithChildren,
  AppProfileRoute: AppProfileRoute,
  AppVolunteersRoute: AppVolunteersRouteWithChildren,
  AppWslInventoryRoute: AppWslInventoryRoute,
  AppIndexRoute: AppIndexRoute,
  AppAccreditationAddRoute: AppAccreditationAddRouteWithChildren,
  AppAccreditationEAccreditationRoute:
    AppAccreditationEAccreditationRouteWithChildren,
  AppAccreditationRecordsRoute: AppAccreditationRecordsRouteWithChildren,
  AppDashboardAccreditationRoute: AppDashboardAccreditationRoute,
  AppDashboardEntriesRoute: AppDashboardEntriesRoute,
  AppDashboardLogisticsRoute: AppDashboardLogisticsRoute,
  AppLogisticsArrivalDepartureRoute:
    AppLogisticsArrivalDepartureRouteWithChildren,
  AppLogisticsDeskRoute: AppLogisticsDeskRoute,
  AppLogisticsFoodBeveragesRoute: AppLogisticsFoodBeveragesRouteWithChildren,
  AppLogisticsTransportationRoute: AppLogisticsTransportationRouteWithChildren,
  AppMeEventsRoute: AppMeEventsRoute,
  AppMeMedalsRoute: AppMeMedalsRoute,
  AppReportsModuleRoute: AppReportsModuleRoute,
  AppReportsSetupRoute: AppReportsSetupRoute,
  AppSettingsAcCardZonesRoute: AppSettingsAcCardZonesRoute,
  AppSettingsAccessCodesRoute: AppSettingsAccessCodesRoute,
  AppSettingsAccessDefaultsRoute: AppSettingsAccessDefaultsRoute,
  AppSettingsAffiliatedOrganizationsRoute:
    AppSettingsAffiliatedOrganizationsRoute,
  AppSettingsAirlinesRoute: AppSettingsAirlinesRoute,
  AppSettingsCountriesRoute: AppSettingsCountriesRoute,
  AppSettingsEntryPointsRoute: AppSettingsEntryPointsRoute,
  AppSettingsEntryWindowsRoute: AppSettingsEntryWindowsRoute,
  AppSettingsEventsRoute: AppSettingsEventsRoute,
  AppSettingsFunctionsRoute: AppSettingsFunctionsRouteWithChildren,
  AppSettingsHandoverLocationsRoute: AppSettingsHandoverLocationsRoute,
  AppSettingsNocStagesRoute: AppSettingsNocStagesRoute,
  AppSettingsOrganizationTypesRoute: AppSettingsOrganizationTypesRoute,
  AppSettingsQuotasRoute: AppSettingsQuotasRoute,
  AppSettingsRegistrationWindowsRoute: AppSettingsRegistrationWindowsRoute,
  AppSettingsResponsibleOrganizationsRoute:
    AppSettingsResponsibleOrganizationsRoute,
  AppSettingsSportClassesRoute: AppSettingsSportClassesRoute,
  AppSettingsSportsRoute: AppSettingsSportsRouteWithChildren,
  AppSettingsSubAgenciesRoute: AppSettingsSubAgenciesRoute,
  AppSettingsVenuesRoute: AppSettingsVenuesRoute,
  AppSettingsZoneAccessRoute: AppSettingsZoneAccessRoute,
  AppUsersIdRoute: AppUsersIdRoute,
  AppUsersGroupsRoute: AppUsersGroupsRouteWithChildren,
  AppUsersModulesRoute: AppUsersModulesRoute,
  AppUsersSignInsRoute: AppUsersSignInsRoute,
  AppDashboardIndexRoute: AppDashboardIndexRoute,
  AppMeIndexRoute: AppMeIndexRoute,
  AppReportsIndexRoute: AppReportsIndexRoute,
  AppUsersIndexRoute: AppUsersIndexRoute,
  AppAccreditationEntriesEbnRoute: AppAccreditationEntriesEbnRoute,
  AppAccreditationEntriesEoiRoute: AppAccreditationEntriesEoiRoute,
  AppAccreditationShortlistSportIdRoute: AppAccreditationShortlistSportIdRoute,
  AppAccreditationEntriesIndexRoute: AppAccreditationEntriesIndexRoute,
  AppAccreditationShortlistIndexRoute: AppAccreditationShortlistIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ChangePasswordRoute: ChangePasswordRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
